var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 697,
    height: 567,
    viewBox: "0 0 697 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.565 519.178L496.053 562.837C500.32 565.301 507.237 565.301 511.504 562.837L586.992 519.178C591.259 516.714 591.259 512.711 586.992 510.247L511.575 466.676C507.308 464.212 500.382 464.212 496.115 466.667L420.583 510.238C416.307 512.72 416.298 516.714 420.565 519.178Z",
    fill: "url(#paint0_linear_430_10862)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39325,
    d: "M613.013 328.12V328.271C613.013 328.493 613.013 328.725 612.996 328.947V329.036C612.933 330.299 612.702 331.562 612.302 332.781C611.626 334.88 610.453 336.855 608.79 338.483C608.115 339.159 607.35 339.791 606.515 340.333C606.301 340.484 606.079 340.618 605.857 340.751L598.913 344.763L372.486 475.572C360.849 482.297 346.491 482.297 334.845 475.572L112.258 346.978L101.332 340.671C100.265 340.066 99.3047 339.319 98.4779 338.483H98.469C96.8065 336.882 95.633 334.951 94.9484 332.87C94.5306 331.607 94.2994 330.281 94.2461 328.956V328.129C94.3083 323.361 96.6731 318.708 101.332 315.977L335.92 180.445C346.989 174.067 360.6 174.067 371.633 180.445L605.866 315.871C610.577 318.593 612.987 323.361 613.013 328.12Z",
    fill: "url(#paint1_radial_430_10862)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M494.078 7.49839C494.985 6.93797 496.114 6.72448 497.208 6.99134C497.59 7.0803 497.981 7.23152 498.345 7.44502L500.035 8.42352L655.082 98.0103C657.784 99.5759 659.456 102.467 659.456 105.598V214.399C659.456 215.102 659.322 215.76 659.1 216.347C658.78 217.175 658.256 217.886 657.607 218.447L661.865 215.636L661.892 215.618C663.43 214.72 664.532 213.056 664.532 211.01V102.209C664.532 99.0778 662.861 96.1867 660.158 94.6211L503.422 4.05582C501.839 3.13958 500.026 3.39755 498.754 4.38496L494.078 7.49839Z",
    fill: "url(#paint2_linear_430_10862)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.052 121.076C492.052 124.697 493.981 128.042 497.11 129.856L651.464 219.025C653.571 220.244 655.989 219.834 657.607 218.456C658.256 217.904 658.781 217.193 659.101 216.356C659.332 215.76 659.456 215.111 659.456 214.408V105.607C659.456 102.476 657.785 99.5848 655.082 98.0192L500.035 8.43241L498.346 7.4539C497.973 7.24041 497.59 7.08919 497.208 7.00023C496.106 6.73337 494.986 6.95575 494.079 7.50728L494.008 7.55175C493.439 7.91647 492.959 8.41462 492.612 9.01062C492.265 9.60662 492.07 10.3005 492.07 11.0744L492.052 121.076Z",
    fill: "#F3F6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M612.195 104.531V138.094L641.124 144.489C640.164 134.491 635.408 123.638 627.487 115.161C622.721 110.055 617.423 106.488 612.195 104.531Z",
    fill: "url(#paint3_linear_430_10862)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M612.195 169.877V138.094L592.21 153.474C593.615 155.493 595.17 157.415 596.877 159.247C601.66 164.353 606.968 167.911 612.195 169.877Z",
    fill: "url(#paint4_linear_430_10862)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M583.47 131.653C583.533 132.151 583.613 132.658 583.701 133.165L612.195 138.085L592.174 105.918C590.378 107.146 588.778 108.738 587.409 110.704C583.577 116.237 582.368 123.745 583.47 131.653Z",
    fill: "url(#paint5_linear_430_10862)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M592.174 105.927L612.195 138.094V104.531C604.86 101.773 597.641 102.182 592.174 105.927Z",
    fill: "url(#paint6_linear_430_10862)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M612.195 138.094V169.877C621.948 173.524 631.461 171.594 636.964 163.668C640.52 158.553 641.827 151.739 641.124 144.481L612.195 138.094Z",
    fill: "url(#paint7_linear_430_10862)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M583.702 133.165C584.725 139.161 587.08 145.334 590.61 151.037C591.117 151.864 591.65 152.664 592.21 153.465L612.195 138.085L583.702 133.165Z",
    fill: "url(#paint8_linear_430_10862)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M568.143 67.9523L568.135 78.8049C568.135 80.6463 566.143 81.7938 564.552 80.8775L509.423 49.0138C508.081 48.2399 507.263 46.8077 507.263 45.2599V33.2687C507.263 31.8988 508.738 31.0448 509.921 31.7298L565.912 64.0739C567.299 64.8745 568.143 66.3511 568.143 67.9523Z",
    fill: "url(#paint9_linear_430_10862)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M568.135 95.7953V146.509C568.135 149.284 565.148 151.019 562.738 149.649L510.632 120.036C508.543 118.844 507.254 116.629 507.254 114.227V61.2718C507.254 59.1902 509.512 57.8826 511.308 58.9234L564.641 89.7375C566.801 90.9828 568.135 93.2957 568.135 95.7953Z",
    fill: "url(#paint10_linear_430_10862)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M552.906 101.115C552.808 101.115 552.701 101.088 552.604 101.035L522.181 83.475C521.896 83.306 521.799 82.9413 521.959 82.6566C522.128 82.372 522.492 82.2741 522.777 82.4342L553.199 99.994C553.484 100.163 553.581 100.528 553.421 100.812C553.315 101.008 553.119 101.115 552.906 101.115Z",
    fill: "url(#paint11_linear_430_10862)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M560.525 114.325C560.427 114.325 560.32 114.298 560.222 114.245L514.562 87.8694C514.277 87.7004 514.179 87.3357 514.339 87.051C514.508 86.7664 514.873 86.6685 515.157 86.8286L560.818 113.204C561.102 113.373 561.2 113.738 561.04 114.022C560.934 114.218 560.738 114.325 560.525 114.325Z",
    fill: "url(#paint12_linear_430_10862)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M560.525 123.105C560.427 123.105 560.32 123.078 560.223 123.025L514.553 96.6404C514.268 96.4714 514.171 96.1067 514.331 95.822C514.5 95.5374 514.864 95.4395 515.149 95.5996L560.818 121.975C561.103 122.144 561.2 122.509 561.04 122.793C560.934 122.998 560.738 123.105 560.525 123.105Z",
    fill: "url(#paint13_linear_430_10862)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M560.525 131.911C560.427 131.911 560.32 131.884 560.222 131.831L513.539 104.86C513.255 104.691 513.157 104.326 513.317 104.041C513.486 103.757 513.85 103.659 514.135 103.819L560.818 130.79C561.102 130.959 561.2 131.324 561.04 131.609C560.934 131.804 560.738 131.911 560.525 131.911Z",
    fill: "url(#paint14_linear_430_10862)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M670.942 259.251C660.389 259.251 649.09 253.575 639.604 243.434C636.643 240.268 633.967 236.772 631.656 233.053C626.846 225.287 623.717 216.783 622.605 208.466C621.138 197.987 622.952 188.442 627.699 181.602C631.993 175.41 638.27 171.852 645.845 171.301C656.984 170.491 669.182 176.229 679.29 187.037C687.682 196.003 693.55 207.345 695.817 218.963C698.102 230.669 696.466 241.282 691.212 248.852C686.9 255.061 680.615 258.628 673.031 259.179C672.338 259.224 671.635 259.251 670.942 259.251ZM628.544 182.189L629.397 182.785C624.943 189.198 623.263 198.218 624.65 208.19C625.726 216.232 628.757 224.451 633.416 231.968C635.647 235.571 638.243 238.96 641.115 242.029C650.663 252.232 662.532 257.872 672.889 257.116C679.823 256.609 685.575 253.344 689.514 247.669C699.773 232.893 694.51 206.331 677.787 188.451C668.248 178.248 656.362 172.617 646.005 173.364C639.07 173.871 633.336 177.127 629.406 182.785L628.544 182.189Z",
    fill: "url(#paint15_linear_430_10862)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M684.003 212.816L682.545 213.705C685.585 223.055 685.203 232.555 680.758 238.96C677.94 243.025 673.814 245.365 668.845 245.729C661.67 246.245 653.473 242.5 646.743 235.651L645.277 236.549C652.024 243.55 659.999 247.464 667.449 247.464C667.956 247.464 668.462 247.446 668.969 247.411C674.463 247.01 679.024 244.422 682.145 239.921C686.928 233.018 687.319 222.788 684.003 212.816ZM650.797 185.48C657.91 185.48 665.849 189.483 672.303 196.377C673.219 197.355 674.09 198.378 674.917 199.428L676.375 198.556C675.486 197.409 674.535 196.297 673.539 195.221C666.222 187.401 657.394 183.256 649.339 183.843C643.845 184.244 639.293 186.823 636.182 191.315C632.741 196.27 631.434 203.182 632.492 210.761C633.026 214.72 634.181 218.731 635.915 222.619L637.373 221.747C635.755 218.064 634.67 214.275 634.164 210.53C633.933 208.884 633.817 207.283 633.817 205.726C633.817 200.496 635.097 195.825 637.569 192.276C640.378 188.22 644.494 185.889 649.464 185.524C649.9 185.498 650.353 185.48 650.797 185.48Z",
    fill: "url(#paint16_linear_430_10862)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M651.055 210.539C650.077 211.944 649.775 213.848 650.05 215.858C650.273 217.495 650.895 219.212 651.864 220.777C652.317 221.516 652.851 222.21 653.455 222.859C656.932 226.577 661.483 227.075 663.635 223.98C665.777 220.893 664.702 215.378 661.226 211.66C657.758 207.95 653.206 207.443 651.055 210.539Z",
    fill: "url(#paint17_linear_430_10862)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M659.19 210.21C658.647 211.001 658.47 212.069 658.63 213.19C658.754 214.106 659.101 215.066 659.643 215.947C659.901 216.356 660.194 216.748 660.532 217.112C662.479 219.194 665.04 219.479 666.24 217.744C667.44 216.009 666.844 212.923 664.888 210.832C662.95 208.76 660.39 208.475 659.19 210.21Z",
    fill: "url(#paint18_linear_430_10862)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M499.964 78.0755C492.692 78.0755 484.895 74.1614 478.361 67.1695C476.316 64.9812 474.476 62.5794 472.884 60.0086C469.568 54.6535 467.417 48.7914 466.643 43.0538C465.63 35.8306 466.883 29.2479 470.155 24.5333C473.116 20.2634 477.445 17.8083 482.664 17.4258C490.345 16.8654 498.746 20.8239 505.725 28.2694C511.513 34.4518 515.558 42.271 517.123 50.2769C518.696 58.3452 517.567 65.6662 513.949 70.8879C510.979 75.1666 506.65 77.6307 501.422 78.0043C500.933 78.0577 500.444 78.0755 499.964 78.0755ZM470.742 24.9514L471.329 25.3606C468.261 29.7817 467.097 35.9996 468.057 42.8759C468.804 48.4178 470.893 54.0842 474.094 59.2703C475.632 61.7522 477.418 64.0917 479.401 66.1999C485.98 73.2363 494.168 77.1236 501.307 76.5988C506.09 76.2519 510.055 74.0013 512.766 70.0873C519.834 59.9019 516.207 41.586 504.676 29.2657C498.097 22.2383 489.909 18.3509 482.762 18.8668C477.987 19.2138 474.031 21.4643 471.32 25.3606L470.742 24.9514Z",
    fill: "url(#paint19_linear_430_10862)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M508.969 46.0605L507.965 46.6742C510.063 53.1235 509.796 59.6706 506.729 64.0828C504.782 66.8849 501.937 68.495 498.514 68.744C493.571 69.0999 487.917 66.5202 483.277 61.7966L482.263 62.4193C486.913 67.2496 492.416 69.9449 497.545 69.9449C497.892 69.9449 498.239 69.936 498.595 69.9094C502.382 69.6336 505.529 67.8456 507.68 64.75C510.988 59.9908 511.254 52.9367 508.969 46.0605ZM486.077 27.2197C490.984 27.2197 496.452 29.9773 500.906 34.7365C501.537 35.4125 502.142 36.1153 502.702 36.8358L503.706 36.2398C503.093 35.4481 502.444 34.6831 501.751 33.9448C496.71 28.5541 490.62 25.6986 485.072 26.0989C481.285 26.3747 478.147 28.1538 475.995 31.2494C473.622 34.6653 472.724 39.4244 473.453 44.655C473.817 47.3859 474.617 50.1524 475.809 52.8299L476.813 52.2339C475.702 49.6987 474.946 47.0834 474.6 44.5037C474.44 43.374 474.36 42.2621 474.36 41.1946C474.36 37.583 475.249 34.3717 476.947 31.9255C478.885 29.1323 481.721 27.5222 485.152 27.2731C485.464 27.2286 485.775 27.2197 486.077 27.2197Z",
    fill: "url(#paint20_linear_430_10862)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M486.264 44.4859C485.588 45.4555 485.384 46.7632 485.571 48.1509C485.722 49.2806 486.149 50.4637 486.824 51.5401C487.135 52.0471 487.5 52.5275 487.918 52.9723C490.318 55.5342 493.456 55.8811 494.932 53.7462C496.408 51.6201 495.67 47.8129 493.27 45.251C490.878 42.7068 487.74 42.3599 486.264 44.4859Z",
    fill: "url(#paint21_linear_430_10862)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M491.865 44.2636C491.492 44.8062 491.368 45.5445 491.474 46.3184C491.563 46.95 491.803 47.6172 492.177 48.2221C492.354 48.5067 492.559 48.7736 492.79 49.0227C494.132 50.4637 495.893 50.6505 496.728 49.4585C497.555 48.2665 497.146 46.1316 495.795 44.6994C494.452 43.2673 492.692 43.0716 491.865 44.2636Z",
    fill: "url(#paint22_linear_430_10862)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M446.632 523.883L437.679 535.803L437.243 536.373L431.794 543.605L411.053 539.326C407.479 541.781 403.425 543.97 398.988 545.882L406.91 555.649L407.817 556.77L402.66 557.98L371.153 565.328L362.245 554.351C356.671 554.76 350.99 554.831 345.282 554.537L336.854 565.764L302.76 558.745L301.373 558.46L299.826 558.14L300.084 557.802L308.263 546.923C303.72 545.09 299.657 543.018 296.11 540.723L275.289 545.58L269.163 538.036L259.597 526.232L267.999 524.275L280.258 521.41C279.494 518.422 279.378 515.37 279.956 512.31L267.705 509.784L259.197 508.032L274.035 488.301L294.545 492.527C295.345 491.957 296.181 491.406 297.026 490.881C297.319 490.685 297.603 490.507 297.906 490.321C299.008 489.653 300.146 489.004 301.337 488.372C303.035 487.465 304.822 486.611 306.68 485.793L305.64 484.512L298.021 475.118L334.694 466.561L343.264 477.146C345.495 476.977 347.745 476.853 350.012 476.782C353.097 476.684 356.199 476.702 359.32 476.826C359.844 476.844 360.378 476.862 360.902 476.888L363.178 473.855L363.338 473.633L364.112 472.601L368.984 466.116L376.434 467.646L406.003 473.739L397.913 484.512C400.473 485.544 402.882 486.647 405.123 487.83C407.034 488.826 408.812 489.876 410.484 490.979L430.549 486.291L446.24 505.639L435.777 508.076L425.997 510.353C426.726 513.387 426.78 516.482 426.122 519.596L436.941 521.829L446.632 523.883Z",
    fill: "url(#paint23_linear_430_10862)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M448.053 501.173L439.101 513.093L438.665 513.662L433.216 520.895L412.474 516.616C408.901 519.071 404.847 521.259 400.41 523.172L408.332 532.939L409.238 534.06L404.082 535.27L372.575 542.617L363.667 531.64C358.092 532.05 352.412 532.121 346.704 531.827L338.276 543.053L304.182 536.035L302.795 535.75L301.248 535.43L301.506 535.092L309.685 524.213C305.142 522.38 301.079 520.307 297.532 518.012L276.711 522.869L270.585 515.326L261.019 503.522L269.421 501.565L281.68 498.7C280.916 495.711 280.8 492.66 281.378 489.6L269.127 487.074L260.619 485.321L275.457 465.591L295.967 469.816C296.767 469.247 297.603 468.696 298.447 468.171C298.741 467.975 299.025 467.797 299.328 467.61C300.43 466.943 301.568 466.294 302.759 465.662C304.457 464.755 306.244 463.901 308.102 463.083L307.062 461.802L299.443 452.408L336.116 443.85L344.686 454.436C346.917 454.267 349.167 454.143 351.434 454.071C354.519 453.974 357.621 453.991 360.742 454.116C361.266 454.134 361.8 454.151 362.324 454.178L364.6 451.145L364.76 450.922L365.534 449.89L370.406 443.406L377.856 444.936L407.425 451.029L399.335 461.802C401.895 462.833 404.304 463.936 406.545 465.12C408.456 466.116 410.234 467.166 411.906 468.269L431.971 463.581L447.662 482.928L437.198 485.366L427.419 487.643C428.148 490.676 428.201 493.772 427.544 496.886L438.363 499.118L448.053 501.173Z",
    fill: "url(#paint24_linear_430_10862)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M381.519 499.109C375.464 507.16 358.315 511.163 343.21 508.058C328.106 504.945 320.771 495.898 326.825 487.848C332.88 479.797 350.029 475.794 365.134 478.899C380.238 482.012 387.573 491.059 381.519 499.109Z",
    fill: "url(#paint25_linear_430_10862)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.322 532.948L411.567 530.866C410.527 531.578 409.451 532.281 408.322 532.948Z",
    stroke: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M308.093 463.118C306.244 463.928 304.457 464.79 302.75 465.698C301.568 466.329 300.43 466.979 299.327 467.646C299.034 467.824 298.741 468.011 298.447 468.197L299.434 452.452L308.093 463.118Z",
    fill: "url(#paint26_linear_430_10862)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M407.434 451.065L406.554 465.155C404.314 463.972 401.904 462.869 399.335 461.837L407.434 451.065Z",
    fill: "url(#paint27_linear_430_10862)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M447.653 482.973L446.764 497.215L438.372 499.172L427.543 496.939C428.21 493.825 428.157 490.73 427.428 487.696L437.207 485.419L447.653 482.973Z",
    fill: "url(#paint28_linear_430_10862)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M448.053 501.164L447.155 515.406L432.326 535.136L433.215 520.903L438.665 513.654L448.053 501.164Z",
    fill: "url(#paint29_linear_430_10862)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M433.215 520.903L432.326 535.136L411.576 530.866L412.465 516.625L433.215 520.903Z",
    fill: "url(#paint30_linear_430_10862)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M412.465 516.625L411.576 530.866L408.331 532.948L400.41 523.172C404.846 521.268 408.9 519.08 412.465 516.625Z",
    fill: "url(#paint31_linear_430_10862)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M409.238 534.078L408.349 548.31L371.686 556.877L372.575 542.635L404.091 535.287L409.238 534.078Z",
    fill: "url(#paint32_linear_430_10862)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M372.575 542.635L371.686 556.877L362.769 545.891L363.666 531.658L372.575 542.635Z",
    fill: "url(#paint33_linear_430_10862)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M363.667 531.658L362.778 545.891C357.204 546.3 351.523 546.38 345.815 546.087L346.704 531.854C352.412 532.138 358.093 532.067 363.667 531.658Z",
    fill: "url(#paint34_linear_430_10862)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M346.704 531.854L345.815 546.087L337.378 557.313L338.267 543.08L346.704 531.854Z",
    fill: "url(#paint35_linear_430_10862)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M309.685 524.23L301.506 535.11C299.781 534.202 298.163 533.259 296.643 532.272L297.532 518.03C301.07 520.316 305.142 522.407 309.685 524.23Z",
    fill: "url(#paint36_linear_430_10862)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M338.268 543.08L337.379 557.313L300.359 549.689L301.248 535.448L302.795 535.768L304.182 536.052L338.268 543.08Z",
    fill: "url(#paint37_linear_430_10862)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M297.531 518.03L296.642 532.272L275.821 537.129L276.71 522.896L297.531 518.03Z",
    fill: "url(#paint38_linear_430_10862)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M276.71 522.896L275.821 537.129L260.13 517.781L261.019 503.539L270.594 515.344L276.71 522.896Z",
    fill: "url(#paint39_linear_430_10862)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M281.681 498.718L269.421 501.582L259.739 499.59L260.628 485.348L269.127 487.1L281.378 489.627C280.8 492.687 280.907 495.747 281.681 498.718Z",
    fill: "url(#paint40_linear_430_10862)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M448.054 501.173L439.101 513.093C397.646 473.57 347.807 462.638 307.062 461.837L299.443 452.443L336.116 443.886L344.686 454.472C346.918 454.303 349.167 454.178 351.434 454.107C354.519 454.009 357.622 454.027 360.742 454.151C361.267 454.169 361.8 454.187 362.324 454.214L364.6 451.18L364.76 450.958L365.534 449.926L370.406 443.441L377.856 444.971L407.425 451.065L399.335 461.837C401.895 462.869 404.305 463.972 406.545 465.155C408.456 466.152 410.234 467.201 411.906 468.304L431.971 463.616L447.663 482.964L437.199 485.401L427.419 487.679C428.148 490.712 428.202 493.808 427.544 496.921L438.363 499.154L448.054 501.173Z",
    fill: "url(#paint41_linear_430_10862)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M613.013 231.861V232.012C613.013 232.235 613.013 232.466 612.996 232.689V232.777C612.933 234.041 612.702 235.304 612.302 236.522C612.018 237.412 611.635 238.284 611.164 239.111C610.542 240.232 609.742 241.29 608.79 242.225C608.115 242.901 607.35 243.532 606.515 244.075C606.301 244.226 606.079 244.359 605.857 244.493L598.913 248.505L372.486 379.313C360.849 386.038 346.491 386.038 334.845 379.313L112.258 250.72L101.332 244.413C100.265 243.808 99.3047 243.061 98.4779 242.225H98.469C96.8065 240.623 95.633 238.693 94.9484 236.611C94.5306 235.348 94.2994 234.023 94.2461 232.697V231.799C94.335 227.058 96.6998 222.441 101.332 219.719L335.92 84.1867C346.989 77.8086 360.6 77.8086 371.633 84.1867L605.866 219.612C610.577 222.325 612.987 227.093 613.013 231.861Z",
    fill: "#F3F6FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M613.013 231.861V232.012C613.013 232.235 613.013 232.466 612.995 232.689V232.777C612.933 234.041 612.702 235.304 612.302 236.522C612.017 237.412 611.635 238.284 611.164 239.111C422.707 223.553 157.314 230.02 94.228 231.79C94.3169 227.049 96.6818 222.432 101.314 219.71L335.902 84.1778C346.971 77.7997 360.582 77.7997 371.614 84.1778L605.847 219.603C610.577 222.325 612.986 227.093 613.013 231.861Z",
    fill: "url(#paint42_linear_430_10862)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M408.207 228.152C408.207 230.207 407.914 232.217 407.336 234.165C407.15 234.859 406.909 235.526 406.643 236.193C400.597 251.351 377.918 262.622 350.909 262.622C325.892 262.622 304.591 252.961 296.794 239.511C296.154 238.444 295.63 237.314 295.185 236.202C294.918 235.535 294.678 234.85 294.474 234.165C293.905 232.226 293.603 230.216 293.603 228.161C293.603 209.124 319.26 193.691 350.909 193.691C355.648 193.691 360.289 194.029 364.698 194.687C389.689 198.423 408.207 211.971 408.207 228.152Z",
    fill: "#287DFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M613.013 240.89V241.033C613.013 244.76 611.618 248.496 608.79 251.253C607.928 252.116 606.959 252.855 605.857 253.504L598.913 257.516L372.486 388.325C360.849 395.067 346.491 395.067 334.845 388.325L112.258 259.749L101.332 253.442C100.265 252.828 99.2958 252.072 98.469 251.253C95.7841 248.665 94.3883 245.222 94.2461 241.709V232.689C94.2994 234.014 94.5306 235.339 94.9484 236.603C95.6419 238.684 96.8065 240.614 98.469 242.216H98.4779C99.3047 243.052 100.256 243.799 101.332 244.404L112.258 250.711L334.845 379.305C346.491 386.03 360.849 386.03 372.486 379.305L598.913 248.496L605.857 244.484C606.079 244.359 606.301 244.217 606.515 244.066C607.35 243.523 608.115 242.901 608.79 242.216C610.453 240.588 611.626 238.622 612.302 236.514C612.693 235.295 612.924 234.032 612.996 232.769V240.196C613.004 240.437 613.013 240.659 613.013 240.89Z",
    fill: "url(#paint43_linear_430_10862)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M116.152 432.126L115.094 430.285L141.614 415.02V290.145L161.803 278.474L162.87 280.315L143.738 291.372V416.248L116.152 432.126Z",
    fill: "url(#paint44_linear_430_10862)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M124.082 436.69L122.997 434.866L148.983 419.272V294.397L169.129 282.717L170.196 284.549L151.099 295.624V420.473L124.082 436.69Z",
    fill: "url(#paint45_linear_430_10862)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M189.283 474.522L188.234 472.681L214.745 457.425V332.541L234.935 320.879L236.002 322.711L216.87 333.768V458.653L189.283 474.522Z",
    fill: "url(#paint46_linear_430_10862)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M197.214 479.086L196.129 477.271L222.115 461.668V336.802L242.27 325.113L243.328 326.946L224.231 338.02V462.869L197.214 479.086Z",
    fill: "url(#paint47_linear_430_10862)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M581.639 437.686L554.062 421.807V296.923L534.93 285.875L535.988 284.033L556.186 295.696V420.58L582.697 435.844L581.639 437.686Z",
    fill: "url(#paint48_linear_430_10862)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M573.709 442.24L546.691 426.033V301.175L527.604 290.1L528.661 288.268L548.816 299.956V424.823L574.802 440.426L573.709 442.24Z",
    fill: "url(#paint49_linear_430_10862)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M508.508 480.082L480.93 464.203V339.319L461.798 328.271L462.856 326.43L483.055 338.092V462.976L509.565 478.241L508.508 480.082Z",
    fill: "url(#paint50_linear_430_10862)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M500.578 484.636L473.56 468.429V343.58L454.473 332.505L455.531 330.664L475.685 342.353V467.228L501.671 482.822L500.578 484.636Z",
    fill: "url(#paint51_linear_430_10862)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M407.345 234.174C407.158 234.868 406.918 235.535 406.651 236.202C400.606 251.36 377.927 262.631 350.918 262.631C325.901 262.631 304.6 252.97 296.803 239.52C296.163 238.453 295.638 237.323 295.194 236.211C294.927 235.544 294.687 234.859 294.482 234.174C299.221 218.011 322.682 205.735 350.918 205.735C355.657 205.735 360.297 206.073 364.707 206.731C386.524 209.96 403.406 220.724 407.345 234.174Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M282.134 216.73L269.288 209.311L269.252 313.184L282.098 320.612L282.134 216.73Z",
    fill: "url(#paint52_linear_430_10862)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M256.432 171.532L243.585 164.335L243.567 298.373L256.414 305.792L256.432 171.532Z",
    fill: "url(#paint53_linear_430_10862)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M230.739 231.55L217.893 224.131L217.875 283.509L230.721 290.928L230.739 231.55Z",
    fill: "url(#paint54_linear_430_10862)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M205.046 238.978L192.199 231.559L192.19 268.689L205.037 276.108L205.046 238.978Z",
    fill: "url(#paint55_linear_430_10862)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M413.595 319.135V327.888C413.595 328.458 413.551 329.018 413.462 329.57C412.057 339.15 398.686 346.649 382.408 346.649C366.121 346.649 352.759 339.15 351.354 329.57C351.265 329.027 351.221 328.458 351.221 327.888V319.135C351.221 319.509 351.238 319.882 351.274 320.256C351.31 320.63 351.354 320.994 351.434 321.359C351.47 321.537 351.514 321.724 351.55 321.902C351.63 322.258 351.745 322.613 351.87 322.969C351.879 322.978 351.87 322.978 351.87 322.978C351.923 323.156 351.994 323.325 352.065 323.503C352.172 323.761 352.279 324.019 352.412 324.277C352.528 324.526 352.661 324.784 352.794 325.024C352.821 325.077 352.848 325.14 352.883 325.193C352.963 325.344 353.052 325.478 353.132 325.62C353.221 325.771 353.319 325.914 353.417 326.065C353.612 326.376 353.826 326.67 354.066 326.972C354.688 327.8 355.417 328.591 356.226 329.33C356.404 329.507 356.599 329.676 356.786 329.837C356.999 330.014 357.222 330.201 357.435 330.37C357.577 330.486 357.711 330.593 357.853 330.708C357.968 330.788 358.075 330.877 358.191 330.957C358.342 331.064 358.484 331.171 358.635 331.269C358.857 331.429 359.089 331.58 359.32 331.74C359.489 331.856 359.666 331.963 359.835 332.078C360.031 332.203 360.244 332.327 360.44 332.452C360.449 332.461 360.458 332.47 360.458 332.47C360.689 332.612 360.929 332.745 361.16 332.879C361.418 333.03 361.676 333.163 361.942 333.306C362.191 333.439 362.449 333.564 362.707 333.688C362.84 333.751 362.974 333.822 363.116 333.884C363.427 334.035 363.747 334.178 364.067 334.32C364.716 334.605 365.392 334.871 366.076 335.129C366.752 335.378 367.437 335.601 368.139 335.823C368.423 335.912 368.717 336.001 369.01 336.081C369.481 336.224 369.953 336.348 370.442 336.464C370.77 336.544 371.108 336.624 371.437 336.704C371.722 336.775 372.024 336.837 372.317 336.891C372.522 336.935 372.726 336.971 372.931 337.015C373.046 337.033 373.18 337.069 373.304 337.078C373.606 337.14 373.909 337.193 374.22 337.238C374.335 337.255 374.433 337.282 374.549 337.291C374.798 337.335 375.056 337.371 375.305 337.407C375.536 337.442 375.758 337.478 375.989 337.496C376.105 337.513 376.229 337.531 376.354 337.54C376.665 337.585 376.976 337.62 377.296 337.647C377.803 337.7 378.318 337.745 378.834 337.771C379.163 337.798 379.501 337.825 379.83 337.834C380.212 337.851 380.603 337.869 380.994 337.878C381.448 337.896 381.892 337.896 382.355 337.896C382.363 337.896 382.363 337.896 382.372 337.896H382.381C382.835 337.896 383.288 337.887 383.741 337.878C384.142 337.869 384.542 337.86 384.933 337.834C385.208 337.816 385.493 337.807 385.768 337.78C386.355 337.745 386.942 337.7 387.52 337.629C387.769 337.611 388.018 337.576 388.258 337.549C388.444 337.531 388.631 337.504 388.818 337.478C389.013 337.46 389.209 337.424 389.396 337.398C389.707 337.353 390 337.318 390.302 337.264C390.329 337.264 390.356 337.255 390.382 337.247C390.756 337.193 391.129 337.131 391.494 337.06C391.583 337.042 391.672 337.024 391.76 337.006C391.992 336.962 392.214 336.917 392.436 336.873C392.703 336.82 392.97 336.757 393.236 336.695C393.565 336.624 393.894 336.544 394.223 336.464C394.436 336.41 394.659 336.357 394.863 336.295C395.139 336.232 395.397 336.152 395.663 336.081C395.983 335.992 396.303 335.903 396.606 335.805C397.308 335.592 398.001 335.361 398.668 335.112C399.353 334.854 400.028 334.587 400.677 334.302C400.998 334.16 401.318 334.017 401.629 333.866C401.807 333.786 401.984 333.697 402.162 333.608C402.375 333.502 402.589 333.395 402.802 333.288C403.051 333.163 403.282 333.039 403.522 332.906C403.745 332.781 403.967 332.656 404.18 332.532C404.26 332.487 404.34 332.443 404.42 332.39C404.598 332.283 404.767 332.176 404.936 332.069C405.194 331.909 405.443 331.74 405.7 331.571C405.878 331.456 406.047 331.34 406.207 331.215C406.447 331.046 406.678 330.877 406.901 330.708C407.043 330.602 407.176 330.495 407.319 330.37C407.532 330.219 407.727 330.05 407.923 329.872C408.172 329.659 408.403 329.454 408.634 329.232C408.865 329.018 409.088 328.796 409.31 328.573C409.523 328.36 409.737 328.129 409.941 327.897C410.581 327.168 411.15 326.403 411.63 325.62C411.71 325.478 411.799 325.344 411.879 325.193C411.915 325.14 411.941 325.077 411.968 325.024C412.11 324.775 412.244 324.526 412.35 324.277C412.475 324.028 412.59 323.77 412.697 323.503C412.768 323.325 412.83 323.156 412.893 322.978C412.946 322.8 413.008 322.622 413.062 322.436C413.115 322.258 413.168 322.089 413.204 321.911H413.213C413.266 321.724 413.302 321.537 413.337 321.35C413.515 320.63 413.595 319.891 413.595 319.135Z",
    fill: "url(#paint56_linear_430_10862)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M413.248 321.92C413.204 322.097 413.159 322.266 413.097 322.444C413.044 322.622 412.982 322.809 412.928 322.987C412.857 323.165 412.795 323.334 412.724 323.512C412.617 323.77 412.51 324.019 412.386 324.286C412.27 324.535 412.137 324.793 412.004 325.033C411.897 325.238 411.781 325.433 411.657 325.629C411.177 326.412 410.608 327.177 409.968 327.906C409.763 328.137 409.559 328.36 409.336 328.582C409.123 328.805 408.901 329.027 408.661 329.241C408.43 329.454 408.19 329.676 407.95 329.881C407.754 330.059 407.55 330.228 407.345 330.379C407.203 330.495 407.069 330.61 406.927 330.717C406.705 330.895 406.474 331.064 406.234 331.224C406.065 331.34 405.896 331.464 405.727 331.58C405.478 331.749 405.22 331.918 404.962 332.078C404.794 332.194 404.616 332.292 404.447 332.398C404.367 332.452 404.287 332.496 404.207 332.541C403.993 332.665 403.771 332.79 403.549 332.914C403.309 333.048 403.069 333.172 402.829 333.297C402.615 333.413 402.411 333.519 402.189 333.617C402.011 333.706 401.833 333.795 401.655 333.875C401.344 334.026 401.024 334.169 400.704 334.311C400.055 334.596 399.379 334.862 398.695 335.12C398.019 335.37 397.335 335.601 396.632 335.814C396.321 335.912 396.01 336.001 395.69 336.09C395.423 336.17 395.165 336.241 394.89 336.304C394.676 336.366 394.463 336.419 394.25 336.473C393.921 336.553 393.592 336.633 393.263 336.704C392.996 336.766 392.729 336.82 392.463 336.882C392.24 336.935 392.018 336.971 391.787 337.015C391.707 337.033 391.609 337.051 391.52 337.069C391.156 337.14 390.782 337.202 390.409 337.255C390.382 337.264 390.356 337.273 390.329 337.273C390.027 337.327 389.724 337.371 389.422 337.407C389.235 337.433 389.04 337.46 388.844 337.487C388.667 337.513 388.471 337.54 388.284 337.558C388.035 337.585 387.795 337.611 387.546 337.638C386.968 337.7 386.382 337.754 385.795 337.789C385.519 337.807 385.235 337.825 384.959 337.843C384.568 337.86 384.168 337.878 383.768 337.887C383.315 337.905 382.861 337.905 382.408 337.905H382.399C382.39 337.905 382.39 337.905 382.381 337.905C381.928 337.905 381.474 337.896 381.021 337.887C380.63 337.878 380.247 337.869 379.856 337.843C379.518 337.825 379.181 337.807 378.86 337.78C378.345 337.754 377.829 337.709 377.322 337.656C377.002 337.629 376.691 337.593 376.38 337.549C376.256 337.54 376.131 337.531 376.016 337.504C375.784 337.487 375.562 337.451 375.331 337.416C375.082 337.389 374.824 337.353 374.575 337.3C374.46 337.291 374.362 337.273 374.246 337.246C373.935 337.193 373.633 337.149 373.331 337.086C373.206 337.069 373.082 337.042 372.957 337.024C372.744 336.98 372.548 336.944 372.344 336.9C372.051 336.846 371.748 336.784 371.464 336.713C371.126 336.633 370.788 336.562 370.468 336.473C369.979 336.357 369.499 336.224 369.037 336.09C368.743 336.01 368.45 335.921 368.165 335.832C367.463 335.619 366.77 335.387 366.103 335.138C365.418 334.88 364.743 334.613 364.094 334.329C363.774 334.186 363.454 334.044 363.142 333.893C363 333.831 362.867 333.759 362.733 333.697C362.476 333.573 362.227 333.448 361.969 333.315C361.702 333.172 361.444 333.039 361.187 332.888C360.947 332.754 360.715 332.621 360.484 332.478C360.475 332.478 360.466 332.47 360.466 332.461C360.262 332.345 360.057 332.212 359.862 332.087C359.684 331.971 359.515 331.874 359.346 331.749C359.115 331.598 358.884 331.438 358.662 331.278C358.511 331.18 358.368 331.064 358.217 330.966C358.102 330.886 357.995 330.797 357.879 330.717C357.737 330.602 357.604 330.504 357.461 330.379C357.248 330.21 357.026 330.032 356.813 329.845C356.626 329.676 356.439 329.507 356.252 329.338C355.443 328.6 354.714 327.808 354.092 326.981C353.852 326.688 353.648 326.376 353.443 326.074C353.345 325.922 353.247 325.78 353.159 325.629C353.043 325.433 352.919 325.238 352.812 325.033C352.67 324.784 352.545 324.535 352.43 324.286C352.314 324.028 352.198 323.779 352.092 323.512C352.021 323.334 351.958 323.165 351.887 322.987C351.887 322.987 351.896 322.987 351.887 322.978C351.772 322.631 351.656 322.266 351.567 321.911C351.523 321.733 351.487 321.546 351.452 321.368C351.381 320.994 351.327 320.63 351.292 320.265C351.256 319.9 351.238 319.527 351.238 319.144V319.135C351.238 308.87 364.956 300.526 381.963 300.383L378.7 309.537C379.981 309.35 381.323 309.243 382.71 309.243C391.787 309.243 399.157 313.673 399.157 319.135C399.157 319.927 399.006 320.701 398.704 321.448C398.641 321.608 398.57 321.759 398.49 321.928H413.248V321.92Z",
    fill: "#F3F6FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M399.139 319.135C399.139 319.927 398.988 320.701 398.686 321.448C398.624 321.608 398.553 321.759 398.473 321.928C396.472 326.038 390.16 329.036 382.683 329.036C374.922 329.036 368.414 325.807 366.681 321.448C366.387 320.71 366.236 319.927 366.236 319.135C366.236 314.501 371.535 310.613 378.683 309.537C379.963 309.35 381.305 309.243 382.692 309.243C391.769 309.235 399.139 313.664 399.139 319.135Z",
    fill: "url(#paint57_linear_430_10862)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M492.843 273.101V281.863C492.843 282.432 492.799 282.993 492.719 283.544C491.305 293.125 477.934 300.624 461.656 300.624C445.369 300.624 432.016 293.125 430.602 283.544C430.522 283.002 430.478 282.432 430.478 281.863V273.101C430.478 273.67 430.522 274.231 430.593 274.782C430.593 274.809 430.602 274.836 430.611 274.871C430.691 275.387 430.806 275.903 430.958 276.41C430.958 276.41 430.958 276.41 430.958 276.419C431.064 276.775 431.189 277.122 431.331 277.477V277.486C431.349 277.513 431.349 277.54 431.367 277.566C431.455 277.798 431.553 278.029 431.669 278.251C431.784 278.5 431.918 278.758 432.051 278.999C432.078 279.052 432.113 279.114 432.14 279.168C432.22 279.319 432.309 279.452 432.389 279.595C433.198 280.92 434.256 282.174 435.518 283.322C435.696 283.5 435.874 283.66 436.061 283.82C436.087 283.847 436.123 283.873 436.167 283.9C436.381 284.087 436.603 284.265 436.825 284.443C436.843 284.46 436.879 284.478 436.905 284.505C437.119 284.665 437.323 284.825 437.545 284.985C437.892 285.234 438.248 285.492 438.63 285.733C438.808 285.857 439.003 285.982 439.19 286.088C439.421 286.24 439.661 286.382 439.892 286.515C440.07 286.631 440.257 286.729 440.444 286.827C440.71 286.978 440.986 287.129 441.261 287.271C441.475 287.387 441.697 287.494 441.919 287.601C442.07 287.681 442.231 287.752 442.382 287.823C442.693 287.974 443.013 288.117 443.333 288.259C443.742 288.437 444.142 288.606 444.56 288.766C445.067 288.97 445.582 289.157 446.107 289.344C447.405 289.789 448.765 290.189 450.178 290.527C450.454 290.589 450.73 290.661 451.014 290.714C451.156 290.75 451.299 290.776 451.45 290.803C451.699 290.856 451.957 290.91 452.205 290.954C452.321 290.972 452.445 290.999 452.561 291.016C452.899 291.079 453.237 291.141 453.583 291.194C453.637 291.212 453.699 291.212 453.752 291.221C454.028 291.274 454.312 291.31 454.597 291.346C454.81 291.381 455.033 291.408 455.246 291.426C455.397 291.443 455.539 291.47 455.69 291.479C455.957 291.515 456.233 291.541 456.491 291.559C457.042 291.621 457.611 291.666 458.18 291.701C458.482 291.728 458.784 291.746 459.095 291.755C459.478 291.773 459.869 291.79 460.269 291.799C460.722 291.817 461.176 291.817 461.638 291.817C462.1 291.817 462.554 291.808 463.007 291.799C463.398 291.79 463.79 291.781 464.181 291.755C464.492 291.737 464.794 291.728 465.096 291.701C465.648 291.666 466.199 291.621 466.75 291.568C467.026 291.541 467.301 291.515 467.577 291.479C467.746 291.461 467.915 291.443 468.075 291.417C468.279 291.399 468.484 291.363 468.679 291.337C468.955 291.301 469.222 291.257 469.479 291.221C469.559 291.212 469.648 291.203 469.728 291.177C470.075 291.123 470.413 291.061 470.751 290.999C471.266 290.91 471.773 290.812 472.271 290.696C472.591 290.625 472.911 290.554 473.222 290.474C473.284 290.465 473.347 290.456 473.4 290.429C473.649 290.376 473.889 290.314 474.129 290.243C474.671 290.109 475.196 289.958 475.72 289.798C476.094 289.682 476.458 289.566 476.823 289.451C477.907 289.086 478.947 288.686 479.952 288.25C480.272 288.108 480.592 287.965 480.903 287.814C481.055 287.743 481.215 287.663 481.366 287.592C481.588 287.485 481.81 287.378 482.024 287.263C482.299 287.111 482.575 286.969 482.841 286.818C483.028 286.72 483.215 286.613 483.393 286.506C483.633 286.373 483.864 286.231 484.095 286.079C484.308 285.955 484.513 285.821 484.708 285.688C484.762 285.652 484.824 285.608 484.886 285.572C485.108 285.421 485.322 285.279 485.526 285.128L485.695 285.003C485.935 284.834 486.158 284.665 486.38 284.496C486.407 284.469 486.433 284.443 486.46 284.434C486.682 284.256 486.904 284.078 487.118 283.891C487.153 283.864 487.189 283.838 487.224 283.811C487.456 283.615 487.687 283.411 487.9 283.197C488.131 282.984 488.353 282.77 488.576 282.539C488.789 282.326 489.011 282.094 489.207 281.863C489.216 281.845 489.225 281.845 489.242 281.827C489.634 281.383 489.998 280.929 490.318 280.466C490.496 280.226 490.665 279.986 490.807 279.737C490.932 279.55 491.047 279.363 491.154 279.159C491.323 278.856 491.483 278.554 491.625 278.243C491.75 277.993 491.865 277.735 491.963 277.469C492.105 277.113 492.23 276.757 492.336 276.401C492.434 276.081 492.514 275.752 492.585 275.423C492.763 274.675 492.843 273.893 492.843 273.101Z",
    fill: "url(#paint58_linear_430_10862)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M492.843 273.101C492.843 273.893 492.763 274.666 492.603 275.431C492.532 275.761 492.452 276.09 492.354 276.41C492.248 276.766 492.123 277.122 491.981 277.477C491.874 277.735 491.768 277.984 491.643 278.251C491.403 278.758 491.136 279.257 490.825 279.746C490.674 279.995 490.505 280.226 490.336 280.475C490.007 280.938 489.643 281.391 489.261 281.836C489.243 281.854 489.234 281.854 489.225 281.872C489.021 282.103 488.816 282.326 488.594 282.548C488.372 282.77 488.149 282.993 487.918 283.206C487.705 283.42 487.474 283.615 487.243 283.82C487.207 283.847 487.171 283.873 487.136 283.9C486.922 284.078 486.7 284.265 486.478 284.443C486.46 284.46 486.425 284.478 486.398 284.505C486.176 284.674 485.953 284.852 485.713 285.012L485.544 285.137C485.331 285.288 485.118 285.43 484.904 285.581C484.851 285.626 484.789 285.661 484.727 285.697C484.522 285.83 484.318 285.964 484.113 286.088C483.882 286.24 483.642 286.382 483.411 286.515C483.233 286.631 483.046 286.729 482.86 286.827C482.593 286.978 482.317 287.129 482.042 287.271C481.828 287.387 481.606 287.494 481.384 287.601C481.233 287.681 481.073 287.752 480.922 287.823C480.61 287.974 480.29 288.117 479.97 288.259C478.975 288.704 477.925 289.095 476.841 289.46C476.476 289.575 476.112 289.7 475.738 289.807C475.214 289.967 474.689 290.118 474.147 290.251C473.907 290.323 473.667 290.385 473.418 290.438C473.365 290.456 473.302 290.474 473.24 290.483C472.929 290.563 472.609 290.634 472.289 290.705C471.791 290.821 471.293 290.919 470.769 291.008C470.431 291.07 470.093 291.132 469.746 291.185C469.666 291.203 469.577 291.221 469.497 291.23C469.231 291.274 468.964 291.31 468.697 291.346C468.493 291.372 468.288 291.399 468.093 291.426C467.933 291.452 467.764 291.479 467.595 291.488C467.319 291.523 467.053 291.55 466.768 291.577C466.226 291.63 465.666 291.675 465.115 291.71C464.812 291.737 464.51 291.755 464.199 291.764C463.808 291.781 463.416 291.799 463.025 291.808C462.572 291.826 462.119 291.826 461.656 291.826C461.194 291.826 460.74 291.817 460.287 291.808C459.887 291.799 459.496 291.79 459.114 291.764C458.802 291.746 458.5 291.737 458.198 291.71C457.629 291.675 457.069 291.63 456.509 291.568C456.242 291.55 455.966 291.515 455.709 291.488C455.557 291.47 455.406 291.452 455.264 291.435C455.051 291.417 454.828 291.381 454.615 291.354C454.331 291.319 454.046 291.274 453.77 291.23C453.717 291.221 453.655 291.212 453.602 291.203C453.255 291.15 452.917 291.088 452.579 291.025C452.464 291.008 452.339 290.981 452.224 290.963C451.975 290.91 451.717 290.865 451.468 290.812C451.317 290.785 451.175 290.758 451.032 290.723C450.748 290.661 450.463 290.598 450.197 290.536C448.783 290.198 447.423 289.798 446.125 289.353C445.6 289.175 445.085 288.979 444.578 288.775C444.16 288.615 443.751 288.446 443.351 288.268C443.031 288.125 442.711 287.983 442.4 287.832C442.249 287.761 442.089 287.681 441.937 287.609C441.715 287.503 441.493 287.396 441.28 287.28C441.004 287.129 440.728 286.987 440.462 286.836C440.275 286.738 440.088 286.631 439.911 286.524C439.67 286.391 439.43 286.248 439.208 286.097C439.021 285.982 438.835 285.866 438.648 285.741C438.275 285.492 437.91 285.243 437.563 284.994C437.341 284.834 437.128 284.674 436.923 284.514C436.897 284.487 436.87 284.46 436.843 284.452C436.621 284.274 436.399 284.087 436.185 283.909C436.141 283.882 436.105 283.856 436.079 283.829C435.892 283.66 435.705 283.5 435.536 283.331C434.274 282.174 433.225 280.92 432.407 279.603C432.292 279.408 432.176 279.212 432.06 279.007C431.918 278.758 431.794 278.509 431.678 278.26C431.571 278.029 431.465 277.807 431.376 277.575C431.358 277.549 431.358 277.522 431.34 277.495V277.486C431.198 277.139 431.074 276.784 430.967 276.428C430.967 276.419 430.967 276.419 430.967 276.419C430.816 275.912 430.691 275.396 430.62 274.88L446.418 276.374C446.24 276.063 446.08 275.743 445.956 275.423C445.654 274.684 445.502 273.91 445.502 273.11C445.502 267.648 452.864 263.218 461.95 263.218C463.31 263.218 464.643 263.316 465.906 263.503V254.527C481.117 255.763 492.843 263.609 492.843 273.101Z",
    fill: "#F3F6FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M478.396 273.101C478.396 273.901 478.245 274.667 477.952 275.414C476.218 279.764 469.701 283.002 461.949 283.002C454.766 283.002 448.649 280.226 446.418 276.366C446.24 276.054 446.08 275.734 445.955 275.414C445.653 274.675 445.502 273.901 445.502 273.101C445.502 267.639 452.863 263.209 461.949 263.209C463.309 263.209 464.643 263.307 465.905 263.494C473.08 264.57 478.396 268.457 478.396 273.101Z",
    fill: "url(#paint59_linear_430_10862)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M566.695 229.362V238.124C566.695 238.693 566.65 239.253 566.57 239.805C565.156 249.385 551.794 256.884 535.516 256.884C527.302 256.884 519.834 254.981 514.268 251.858C508.792 248.798 505.156 244.555 504.454 239.805C504.374 239.262 504.329 238.693 504.329 238.124V229.362C504.329 229.735 504.347 230.118 504.382 230.491C504.418 230.856 504.462 231.23 504.542 231.594C504.685 232.333 504.898 233.044 505.183 233.747C505.2 233.774 505.2 233.8 505.218 233.827C505.307 234.058 505.405 234.29 505.52 234.512C505.636 234.761 505.769 235.019 505.903 235.259C505.929 235.313 505.965 235.375 505.992 235.428C506.036 235.517 506.098 235.606 506.152 235.695C506.232 235.838 506.32 235.971 506.409 236.113C507.005 237.047 507.734 237.955 508.561 238.809C508.774 239.031 509.005 239.253 509.237 239.467C509.45 239.68 509.681 239.876 509.912 240.072C510.126 240.25 510.339 240.437 510.561 240.606C510.695 240.721 510.837 240.837 510.979 240.944C511.192 241.113 511.415 241.273 511.646 241.433C511.877 241.602 512.108 241.762 512.348 241.913C512.553 242.056 512.757 242.189 512.962 242.313C513.166 242.447 513.371 242.571 513.575 242.687C513.833 242.847 514.1 242.998 514.375 243.15C514.606 243.274 514.846 243.399 515.077 243.523C515.291 243.639 515.495 243.737 515.718 243.844C515.895 243.932 516.064 244.021 516.251 244.101C516.562 244.253 516.882 244.395 517.202 244.537C517.665 244.742 518.136 244.938 518.616 245.116C518.811 245.196 519.007 245.267 519.211 245.347C519.887 245.596 520.572 245.827 521.274 246.041C521.585 246.139 521.896 246.228 522.216 246.316C522.661 246.45 523.123 246.566 523.585 246.69C523.897 246.77 524.217 246.841 524.537 246.912C524.555 246.921 524.563 246.921 524.581 246.921C524.883 246.993 525.186 247.064 525.488 247.117C525.799 247.188 526.119 247.251 526.439 247.295C526.742 247.357 527.044 247.411 527.355 247.455C527.471 247.473 527.568 247.5 527.684 247.508C527.933 247.553 528.182 247.589 528.44 247.624C528.662 247.66 528.893 247.695 529.124 247.713C529.249 247.731 529.373 247.749 529.498 247.766C529.791 247.802 530.093 247.838 530.395 247.864C530.911 247.918 531.436 247.962 531.969 247.989C532.298 248.016 532.636 248.042 532.974 248.051C533.356 248.069 533.747 248.087 534.138 248.096C534.583 248.113 535.036 248.113 535.498 248.113C535.507 248.113 535.507 248.113 535.516 248.113H535.525C535.979 248.113 536.432 248.104 536.885 248.096C537.285 248.087 537.685 248.078 538.077 248.051C538.352 248.033 538.637 248.024 538.912 247.998C539.499 247.962 540.086 247.918 540.664 247.847C540.922 247.829 541.179 247.793 541.437 247.766C541.802 247.731 542.157 247.686 542.513 247.633C542.824 247.589 543.117 247.553 543.42 247.5C543.464 247.491 543.526 247.482 543.571 247.473C543.944 247.42 544.309 247.357 544.673 247.286C544.735 247.277 544.789 247.268 544.851 247.25C545.1 247.206 545.349 247.162 545.589 247.099C545.873 247.046 546.158 246.984 546.434 246.921C546.745 246.859 547.056 246.779 547.367 246.708C547.616 246.646 547.865 246.583 548.105 246.521C548.407 246.441 548.701 246.361 548.994 246.272C549.252 246.192 549.51 246.121 549.767 246.041C550.123 245.934 550.47 245.818 550.825 245.694C551.866 245.347 552.879 244.955 553.839 244.528C554.159 244.386 554.479 244.244 554.79 244.093C554.915 244.03 555.039 243.977 555.164 243.915C555.715 243.648 556.248 243.372 556.764 243.078C556.942 242.981 557.111 242.883 557.28 242.776C557.52 242.643 557.751 242.5 557.973 242.358C558.222 242.207 558.462 242.056 558.693 241.895C558.978 241.709 559.262 241.522 559.529 241.317C559.787 241.139 560.036 240.944 560.276 240.757C560.302 240.739 560.329 240.712 560.356 240.694C560.605 240.508 560.845 240.303 561.085 240.09C561.334 239.885 561.574 239.672 561.805 239.449C562.036 239.236 562.258 239.013 562.481 238.791C562.694 238.577 562.907 238.346 563.103 238.115C563.121 238.106 563.121 238.097 563.138 238.079C563.512 237.652 563.867 237.216 564.179 236.772C564.223 236.7 564.276 236.638 564.321 236.567C564.463 236.38 564.588 236.184 564.703 235.989C564.721 235.971 564.73 235.944 564.748 235.927C564.854 235.758 564.961 235.588 565.059 235.419C565.085 235.366 565.121 235.304 565.148 235.25C565.263 235.037 565.388 234.806 565.494 234.583C565.521 234.53 565.539 234.485 565.557 234.441C565.663 234.227 565.752 234.023 565.832 233.809C565.85 233.783 565.85 233.756 565.868 233.729C565.939 233.551 566.001 233.382 566.063 233.196C566.241 232.689 566.374 232.19 566.481 231.674C566.606 230.936 566.695 230.153 566.695 229.362Z",
    fill: "url(#paint60_linear_430_10862)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M566.695 229.362C566.695 230.153 566.615 230.927 566.455 231.692C566.348 232.208 566.206 232.715 566.037 233.213C565.975 233.391 565.912 233.569 565.841 233.747C565.823 233.774 565.823 233.8 565.806 233.827C565.726 234.041 565.628 234.245 565.53 234.459C565.512 234.503 565.494 234.548 565.468 234.601C565.361 234.823 565.245 235.046 565.121 235.268C564.997 235.499 564.863 235.722 564.721 235.944L552.23 229.904C552.177 230.509 552.017 231.105 551.794 231.683C550.061 236.033 543.553 239.271 535.792 239.271C531.285 239.271 527.213 238.177 524.243 236.416L518.607 245.133C518.127 244.955 517.656 244.76 517.193 244.555C516.873 244.413 516.553 244.27 516.242 244.119C516.064 244.039 515.887 243.95 515.709 243.861C515.495 243.763 515.282 243.648 515.069 243.541C514.829 243.417 514.589 243.292 514.366 243.167C514.091 243.016 513.824 242.865 513.566 242.705C513.353 242.589 513.157 242.456 512.953 242.331C512.739 242.207 512.544 242.073 512.339 241.931C512.099 241.78 511.868 241.62 511.637 241.451C511.406 241.29 511.192 241.13 510.97 240.961C510.828 240.855 510.686 240.748 510.552 240.623C510.33 240.454 510.108 240.276 509.903 240.09C509.672 239.885 509.45 239.68 509.228 239.485C508.997 239.271 508.774 239.049 508.552 238.826C507.716 237.972 506.996 237.074 506.401 236.131C506.312 235.989 506.223 235.855 506.143 235.713C506.054 235.571 505.974 235.428 505.894 235.277C505.752 235.028 505.627 234.779 505.512 234.53C505.405 234.299 505.298 234.076 505.209 233.845C505.192 233.818 505.192 233.792 505.174 233.765C504.898 233.062 504.676 232.342 504.534 231.612C504.463 231.247 504.409 230.883 504.374 230.509C504.338 230.136 504.32 229.762 504.32 229.379C504.32 219.016 518.278 210.619 535.499 210.619C552.728 210.601 566.695 218.998 566.695 229.362Z",
    fill: "#F3F6FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M552.248 229.362C552.248 229.54 552.239 229.717 552.23 229.904C552.177 230.509 552.017 231.105 551.794 231.683C550.061 236.033 543.553 239.271 535.792 239.271C531.284 239.271 527.213 238.177 524.243 236.416C522.092 235.144 520.518 233.507 519.798 231.683C519.496 230.945 519.345 230.162 519.345 229.371C519.345 223.909 526.706 219.479 535.792 219.479C544.878 219.47 552.248 223.9 552.248 229.362Z",
    fill: "url(#paint61_linear_430_10862)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M413.595 319.126C413.595 319.891 413.515 320.63 413.381 321.359C413.337 321.546 413.301 321.733 413.257 321.919H398.481C398.561 321.759 398.632 321.608 398.695 321.439C398.997 320.701 399.148 319.918 399.148 319.126C399.148 313.664 391.778 309.234 382.701 309.234C381.314 309.234 379.972 309.341 378.691 309.528L381.954 300.375C382.105 300.366 382.256 300.366 382.408 300.366C399.619 300.375 413.595 308.772 413.595 319.126Z",
    fill: "url(#paint62_linear_430_10862)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M465.905 254.527V263.503C464.643 263.316 463.309 263.218 461.949 263.218C452.863 263.218 445.502 267.648 445.502 273.11C445.502 273.91 445.653 274.675 445.956 275.423C446.08 275.743 446.231 276.063 446.418 276.374L430.62 274.88C430.611 274.844 430.602 274.818 430.602 274.791C430.522 274.24 430.486 273.679 430.486 273.11V273.386C430.478 273.297 430.478 273.199 430.478 273.11C430.478 262.746 444.444 254.349 461.665 254.349C463.096 254.34 464.519 254.394 465.905 254.527Z",
    fill: "url(#paint63_linear_430_10862)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M564.721 235.944C564.703 235.962 564.694 235.989 564.676 236.007C564.561 236.202 564.427 236.389 564.294 236.585C564.249 236.656 564.205 236.718 564.152 236.789C563.832 237.234 563.476 237.67 563.111 238.097C563.094 238.115 563.094 238.124 563.076 238.133C562.88 238.364 562.667 238.586 562.454 238.809C562.24 239.031 562.009 239.253 561.778 239.467C561.547 239.68 561.307 239.903 561.058 240.107C560.827 240.312 560.587 240.517 560.329 240.712C560.311 240.73 560.275 240.757 560.249 240.775C560.009 240.961 559.76 241.148 559.502 241.335C559.226 241.531 558.951 241.726 558.666 241.913C558.426 242.073 558.195 242.225 557.946 242.376C557.724 242.527 557.493 242.66 557.253 242.794C557.084 242.901 556.906 242.998 556.737 243.096C556.221 243.381 555.688 243.666 555.137 243.932C555.021 243.995 554.888 244.048 554.763 244.11C554.452 244.262 554.132 244.404 553.812 244.546C552.843 244.964 551.839 245.356 550.798 245.712C550.452 245.827 550.096 245.952 549.74 246.058C549.492 246.139 549.234 246.21 548.967 246.29C548.674 246.37 548.38 246.459 548.078 246.539C547.829 246.61 547.589 246.672 547.34 246.726C547.029 246.806 546.727 246.877 546.407 246.939C546.131 247.01 545.846 247.064 545.562 247.117C545.313 247.17 545.073 247.224 544.824 247.268C544.771 247.286 544.709 247.295 544.646 247.304C544.282 247.375 543.908 247.437 543.544 247.491C543.491 247.508 543.437 247.508 543.393 247.517C543.09 247.571 542.788 247.606 542.486 247.651C542.13 247.704 541.775 247.749 541.41 247.784C541.161 247.82 540.904 247.846 540.637 247.864C540.059 247.927 539.472 247.98 538.885 248.016C538.61 248.033 538.325 248.051 538.05 248.069C537.659 248.087 537.258 248.104 536.858 248.113C536.405 248.131 535.952 248.131 535.498 248.131H535.489C535.48 248.131 535.48 248.131 535.472 248.131C535.018 248.131 534.565 248.122 534.111 248.113C533.72 248.104 533.338 248.096 532.947 248.069C532.609 248.051 532.271 248.033 531.942 248.007C531.409 247.98 530.884 247.935 530.369 247.882C530.066 247.855 529.764 247.82 529.471 247.784C529.346 247.766 529.222 247.758 529.097 247.731C528.866 247.713 528.635 247.677 528.413 247.642C528.164 247.615 527.906 247.58 527.657 247.526C527.541 247.517 527.444 247.5 527.328 247.473C527.017 247.419 526.715 247.375 526.412 247.313C526.092 247.259 525.772 247.197 525.461 247.135C525.15 247.081 524.857 247.01 524.554 246.939C524.536 246.939 524.519 246.939 524.51 246.93C524.19 246.859 523.87 246.779 523.559 246.708C523.096 246.592 522.634 246.468 522.189 246.334C521.869 246.245 521.549 246.156 521.247 246.058C520.545 245.845 519.851 245.614 519.185 245.365C518.98 245.285 518.784 245.213 518.589 245.133L524.225 236.416C527.195 238.177 531.266 239.271 535.774 239.271C543.535 239.271 550.043 236.042 551.776 231.683C551.999 231.105 552.15 230.518 552.212 229.904L564.721 235.944Z",
    fill: "url(#paint64_linear_430_10862)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M303.862 307.624L305.507 306.673L279.529 261.67L253.943 276.454L222.071 235.971L203.17 246.886L190.715 218.144L171.334 206.927L170.383 208.573L189.23 219.47L202.281 249.59L221.6 238.435L253.472 278.919L278.836 264.268L303.862 307.624Z",
    fill: "url(#paint65_linear_430_10862)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M171.805 200.905V215.636L165.431 204.579L171.805 200.905Z",
    fill: "url(#paint66_linear_430_10862)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M276.515 263.102C276.622 265.344 277.902 267.105 279.378 267.034C280.853 266.963 281.956 265.086 281.849 262.844C281.742 260.603 280.462 258.841 278.986 258.913C277.519 258.984 276.408 260.861 276.515 263.102Z",
    fill: "url(#paint67_linear_430_10862)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M251.027 277.771C251.133 280.013 252.414 281.774 253.889 281.703C255.365 281.632 256.467 279.755 256.361 277.513C256.254 275.271 254.974 273.51 253.498 273.581C252.031 273.652 250.92 275.529 251.027 277.771Z",
    fill: "url(#paint68_linear_430_10862)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M219.172 237.706C219.279 239.947 220.559 241.709 222.035 241.637C223.511 241.566 224.613 239.689 224.506 237.448C224.4 235.206 223.119 233.445 221.644 233.516C220.168 233.587 219.065 235.464 219.172 237.706Z",
    fill: "url(#paint69_linear_430_10862)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M200.059 248.362C200.166 250.604 201.446 252.365 202.922 252.294C204.397 252.223 205.5 250.346 205.393 248.104C205.286 245.863 204.006 244.101 202.53 244.173C201.055 244.253 199.952 246.121 200.059 248.362Z",
    fill: "url(#paint70_linear_430_10862)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M201.819 402.913L101.278 460.992L0.737793 402.895L100.434 345.306L101.278 344.817L201.819 402.913Z",
    fill: "#F3F6FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0.746582 402.895V436.085L101.278 494.163V460.992L0.746582 402.895Z",
    fill: "url(#paint71_linear_430_10862)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M101.278 494.163L201.819 436.085V402.913L101.278 460.992V494.163Z",
    fill: "url(#paint72_linear_430_10862)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6864 456.954C68.3307 457.469 68.2152 458.172 68.3219 458.911C68.4019 459.515 68.633 460.147 68.9886 460.725C69.1575 460.992 69.3531 461.25 69.5754 461.49C70.8556 462.86 72.527 463.038 73.3182 461.908C74.1095 460.77 73.7094 458.742 72.4292 457.381C71.1579 456.002 69.4776 455.815 68.6864 456.954Z",
    fill: "url(#paint73_linear_430_10862)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4256 462.22C77.07 462.736 76.9544 463.438 77.0611 464.177C77.1411 464.782 77.3723 465.413 77.7279 465.991C77.8968 466.258 78.0924 466.516 78.3146 466.756C79.5948 468.126 81.2662 468.304 82.0575 467.174C82.8487 466.036 82.4486 464.008 81.1684 462.647C79.8882 461.268 78.208 461.081 77.4256 462.22Z",
    fill: "url(#paint74_linear_430_10862)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1561 467.308C85.8005 467.824 85.6849 468.527 85.7916 469.265C85.8716 469.87 86.1027 470.501 86.4584 471.08C86.6273 471.346 86.8229 471.604 87.0451 471.845C88.3253 473.215 89.9967 473.392 90.7879 472.263C91.5792 471.124 91.1791 469.096 89.8989 467.735C88.6187 466.365 86.9473 466.178 86.1561 467.308Z",
    fill: "url(#paint75_linear_430_10862)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5981 427.554V430.409C16.5981 430.765 16.7848 431.094 17.096 431.272L27.2221 437.125C27.5599 437.321 27.9866 437.072 27.9866 436.681V433.861C27.9866 433.434 27.7555 433.042 27.391 432.829L17.4249 427.073C17.0604 426.86 16.5981 427.127 16.5981 427.554Z",
    fill: "url(#paint76_linear_430_10862)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M192.493 423.231C192.849 423.747 192.964 424.449 192.858 425.188C192.778 425.793 192.547 426.424 192.191 427.002C192.022 427.269 191.827 427.527 191.604 427.767C190.324 429.137 188.653 429.315 187.861 428.185C187.07 427.047 187.47 425.019 188.75 423.658C190.022 422.279 191.702 422.092 192.493 423.231Z",
    fill: "url(#paint77_linear_430_10862)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M183.754 428.506C184.11 429.022 184.225 429.724 184.119 430.463C184.039 431.068 183.807 431.699 183.452 432.277C183.283 432.544 183.087 432.802 182.865 433.042C181.585 434.412 179.913 434.59 179.122 433.46C178.331 432.322 178.731 430.294 180.011 428.933C181.291 427.554 182.972 427.367 183.754 428.506Z",
    fill: "url(#paint78_linear_430_10862)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M175.024 433.594C175.379 434.11 175.495 434.813 175.388 435.551C175.308 436.156 175.077 436.787 174.721 437.366C174.552 437.632 174.357 437.89 174.135 438.131C172.854 439.501 171.183 439.678 170.392 438.549C169.6 437.41 170.001 435.382 171.281 434.021C172.561 432.642 174.232 432.455 175.024 433.594Z",
    fill: "url(#paint79_linear_430_10862)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M128.527 460.645V463.501C128.527 463.856 128.34 464.186 128.029 464.363L117.903 470.217C117.565 470.412 117.139 470.163 117.139 469.772V466.952C117.139 466.525 117.37 466.134 117.734 465.92L127.7 460.165C128.065 459.951 128.527 460.218 128.527 460.645Z",
    fill: "url(#paint80_linear_430_10862)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1225 397.896V403.465C15.1225 404.586 13.7801 405.502 12.1265 405.502C10.4729 405.502 9.12158 404.586 9.12158 403.465V397.896C9.12158 399.017 10.464 399.933 12.1265 399.933C13.789 399.933 15.1225 399.017 15.1225 397.896Z",
    fill: "url(#paint81_linear_430_10862)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1225 397.896C15.1225 399.017 13.7801 399.933 12.1265 399.933C10.4729 399.933 9.12158 399.017 9.12158 397.896C9.12158 396.775 10.464 395.859 12.1265 395.859C13.789 395.859 15.1225 396.766 15.1225 397.896Z",
    fill: "url(#paint82_linear_430_10862)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M101.278 460.992C101.278 460.992 119.397 392.408 100.434 345.306L101.278 344.817L201.819 402.913L101.278 460.992Z",
    fill: "url(#paint83_linear_430_10862)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M195.889 397.149V402.718C195.889 403.838 194.546 404.755 192.893 404.755C191.239 404.755 189.888 403.838 189.888 402.718V397.149C189.888 398.27 191.23 399.186 192.893 399.186C194.555 399.186 195.889 398.27 195.889 397.149Z",
    fill: "url(#paint84_linear_430_10862)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M195.889 397.149C195.889 398.27 194.546 399.186 192.893 399.186C191.239 399.186 189.888 398.27 189.888 397.149C189.888 396.028 191.23 395.112 192.893 395.112C194.555 395.112 195.889 396.019 195.889 397.149Z",
    fill: "url(#paint85_linear_430_10862)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M104.283 448.601V454.169C104.283 455.29 102.941 456.206 101.287 456.206C99.6336 456.206 98.2822 455.29 98.2822 454.169V448.601C98.2822 449.721 99.6247 450.638 101.287 450.638C102.941 450.638 104.283 449.721 104.283 448.601Z",
    fill: "url(#paint86_linear_430_10862)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M104.283 448.601C104.283 449.721 102.941 450.638 101.287 450.638C99.6336 450.638 98.2822 449.721 98.2822 448.601C98.2822 447.48 99.6247 446.564 101.287 446.564C102.941 446.564 104.283 447.471 104.283 448.601Z",
    fill: "url(#paint87_linear_430_10862)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 436.102V469.283L101.34 527.362V494.199L0.799805 436.102Z",
    fill: "url(#paint88_linear_430_10862)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M101.34 527.362L201.872 469.292V436.12L101.34 494.199V527.362Z",
    fill: "url(#paint89_linear_430_10862)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7489 490.151C68.3932 490.667 68.2777 491.37 68.3844 492.109C68.4644 492.713 68.6955 493.345 69.0511 493.923C69.22 494.19 69.4156 494.448 69.6379 494.688C70.9181 496.058 72.5895 496.236 73.3807 495.106C74.1719 493.968 73.7719 491.94 72.4917 490.579C71.2115 489.2 69.5312 489.013 68.7489 490.151Z",
    fill: "url(#paint90_linear_430_10862)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4788 495.427C77.1232 495.943 77.0077 496.645 77.1143 497.384C77.1943 497.989 77.4255 498.62 77.7811 499.198C77.95 499.465 78.1456 499.723 78.3679 499.963C79.6481 501.333 81.3194 501.511 82.1107 500.381C82.9019 499.243 82.5019 497.215 81.2216 495.854C79.9414 494.475 78.2701 494.288 77.4788 495.427Z",
    fill: "url(#paint91_linear_430_10862)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2093 500.515C85.8537 501.031 85.7381 501.734 85.8448 502.472C85.9248 503.077 86.156 503.708 86.5116 504.287C86.6805 504.553 86.8761 504.811 87.0983 505.052C88.3785 506.421 90.0499 506.599 90.8412 505.47C91.6324 504.331 91.2323 502.303 89.9521 500.942C88.6719 499.563 87.0005 499.376 86.2093 500.515Z",
    fill: "url(#paint92_linear_430_10862)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6514 460.761V463.616C16.6514 463.972 16.8381 464.301 17.1492 464.479L27.2753 470.332C27.6131 470.528 28.0399 470.279 28.0399 469.888V467.068C28.0399 466.641 27.8087 466.249 27.4442 466.036L17.4782 460.28C17.1137 460.067 16.6514 460.334 16.6514 460.761Z",
    fill: "#F3F6FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M192.546 456.438C192.902 456.954 193.017 457.656 192.911 458.395C192.831 458.999 192.599 459.631 192.244 460.209C192.075 460.476 191.879 460.734 191.657 460.974C190.377 462.344 188.705 462.522 187.914 461.392C187.123 460.254 187.523 458.226 188.803 456.865C190.083 455.486 191.755 455.299 192.546 456.438Z",
    fill: "url(#paint93_linear_430_10862)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M183.816 461.704C184.171 462.22 184.287 462.922 184.18 463.661C184.1 464.266 183.869 464.897 183.513 465.475C183.344 465.742 183.149 466 182.927 466.24C181.646 467.61 179.975 467.788 179.184 466.659C178.392 465.52 178.793 463.492 180.073 462.131C181.344 460.752 183.024 460.574 183.816 461.704Z",
    fill: "url(#paint94_linear_430_10862)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M175.076 466.792C175.432 467.308 175.547 468.011 175.441 468.749C175.361 469.354 175.13 469.985 174.774 470.564C174.605 470.83 174.409 471.088 174.187 471.329C172.907 472.698 171.236 472.876 170.444 471.747C169.653 470.608 170.053 468.58 171.333 467.219C172.614 465.849 174.294 465.662 175.076 466.792Z",
    fill: "url(#paint95_linear_430_10862)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M128.58 493.852V496.708C128.58 497.063 128.394 497.393 128.083 497.57L117.956 503.424C117.619 503.619 117.192 503.37 117.192 502.979V500.159C117.192 499.732 117.423 499.341 117.788 499.127L127.754 493.372C128.127 493.158 128.589 493.425 128.58 493.852Z",
    fill: "#F3F6FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0.746582 469.256V502.445L101.278 560.524V527.353L0.746582 469.256Z",
    fill: "url(#paint96_linear_430_10862)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M101.278 560.524L201.819 502.445V469.274L101.278 527.353V560.524Z",
    fill: "url(#paint97_linear_430_10862)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6864 523.305C68.3307 523.821 68.2152 524.524 68.3219 525.262C68.4019 525.867 68.633 526.499 68.9886 527.077C69.1575 527.344 69.3531 527.602 69.5754 527.842C70.8556 529.212 72.527 529.39 73.3182 528.26C74.1095 527.121 73.7094 525.093 72.4292 523.732C71.1579 522.362 69.4776 522.175 68.6864 523.305Z",
    fill: "url(#paint98_linear_430_10862)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4256 528.58C77.07 529.096 76.9544 529.799 77.0611 530.537C77.1411 531.142 77.3723 531.774 77.7279 532.352C77.8968 532.619 78.0924 532.877 78.3146 533.117C79.5948 534.487 81.2662 534.665 82.0575 533.535C82.8487 532.396 82.4486 530.368 81.1684 529.007C79.8882 527.628 78.208 527.442 77.4256 528.58Z",
    fill: "url(#paint99_linear_430_10862)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1561 533.668C85.8005 534.184 85.6849 534.887 85.7916 535.625C85.8716 536.23 86.1027 536.862 86.4584 537.44C86.6273 537.707 86.8229 537.965 87.0451 538.205C88.3253 539.575 89.9967 539.753 90.7879 538.623C91.5792 537.485 91.1791 535.456 89.8989 534.095C88.6187 532.725 86.9473 532.539 86.1561 533.668Z",
    fill: "url(#paint100_linear_430_10862)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5981 493.914V496.77C16.5981 497.126 16.7848 497.455 17.096 497.633L27.2221 503.486C27.5599 503.682 27.9866 503.433 27.9866 503.041V500.221C27.9866 499.794 27.7555 499.403 27.391 499.19L17.4249 493.434C17.0604 493.22 16.5981 493.487 16.5981 493.914Z",
    fill: "url(#paint101_linear_430_10862)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M192.493 489.591C192.849 490.107 192.964 490.81 192.858 491.548C192.778 492.153 192.547 492.785 192.191 493.363C192.022 493.63 191.827 493.888 191.604 494.128C190.324 495.498 188.653 495.676 187.861 494.546C187.07 493.407 187.47 491.379 188.75 490.018C190.022 488.639 191.702 488.453 192.493 489.591Z",
    fill: "url(#paint102_linear_430_10862)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M183.754 494.857C184.11 495.373 184.225 496.076 184.119 496.814C184.039 497.419 183.807 498.051 183.452 498.629C183.283 498.896 183.087 499.154 182.865 499.394C181.585 500.764 179.913 500.942 179.122 499.812C178.331 498.673 178.731 496.645 180.011 495.284C181.291 493.914 182.972 493.728 183.754 494.857Z",
    fill: "url(#paint103_linear_430_10862)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M175.024 499.954C175.379 500.47 175.495 501.173 175.388 501.911C175.308 502.516 175.077 503.148 174.721 503.726C174.552 503.993 174.357 504.251 174.135 504.491C172.854 505.861 171.183 506.039 170.392 504.909C169.6 503.771 170.001 501.742 171.281 500.381C172.561 499.003 174.232 498.816 175.024 499.954Z",
    fill: "url(#paint104_linear_430_10862)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M128.527 527.006V529.861C128.527 530.217 128.34 530.546 128.029 530.724L117.903 536.577C117.565 536.773 117.139 536.524 117.139 536.133V533.313C117.139 532.886 117.37 532.494 117.734 532.281L127.7 526.525C128.074 526.312 128.527 526.579 128.527 527.006Z",
    fill: "url(#paint105_linear_430_10862)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M135.061 264.019C135.061 264.019 135.453 260.024 136.519 260.069C137.586 260.113 141.205 253.744 142.156 254.1C143.116 254.447 139.489 259.535 140.742 260.167C141.996 260.798 145.134 263.236 143.463 264.908C141.791 266.58 138.306 268.466 138.306 268.466L134.688 266.652L135.061 264.019Z",
    fill: "url(#paint106_linear_430_10862)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2288 411.693C98.2288 411.693 96.0329 418.818 102.736 419.005C107.101 419.13 116.169 412.921 115.787 411.595C115.405 410.27 106.008 411.506 106.008 411.506L102.229 409.594L98.2288 411.693Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1243 406.596C85.1243 406.596 82.9284 413.721 89.6317 413.908C93.9969 414.033 103.065 407.824 102.683 406.498C102.3 405.173 92.9034 406.409 92.9034 406.409L89.125 404.497L85.1243 406.596Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3618 358.649L97.6423 411.56C97.6423 411.56 98.6558 412.796 103.172 412.414C106.702 412.12 107.315 411.337 107.315 411.337L108.417 359.814L105.519 353.721L94.3618 358.649Z",
    fill: "url(#paint107_linear_430_10862)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2661 353.561L84.5466 406.472C84.5466 406.472 85.5601 407.708 90.0764 407.325C93.6058 407.032 94.2193 406.249 94.2193 406.249L95.3217 354.726L92.4234 348.633L81.2661 353.561Z",
    fill: "url(#paint108_linear_430_10862)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M80.706 280.822C80.706 280.822 71.2467 293.018 70.8378 299.672C70.4377 306.326 77.6833 310.266 77.6833 310.266C77.6833 310.266 80.7327 308.007 81.0172 307.767C81.3016 307.527 92.0856 288.108 92.0056 287.787C91.9344 287.476 80.706 280.822 80.706 280.822Z",
    fill: "url(#paint109_linear_430_10862)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3085 270.094L93.8907 276.828L102.114 276.357C102.114 276.357 102.479 269.507 103.048 269.027C103.608 268.546 103.608 268.546 103.608 268.546L102.968 267.497L93.5884 266.02L94.3085 270.094Z",
    fill: "url(#paint110_linear_430_10862)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M106.372 256.626C106.372 256.626 108.088 260.603 108.035 264.846C107.981 269.089 106.372 271.562 106.372 271.562C106.372 271.562 100.416 272.852 97.9977 270.592C95.5795 268.333 96.2818 265.869 96.2818 265.869L97.4109 262.159L100.523 254.963L103.047 254.696L106.372 256.626Z",
    fill: "url(#paint111_linear_430_10862)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M141.151 268.653C141.151 268.653 124.829 295.722 122.366 298.4C121.139 299.734 118.525 299.076 116.205 298.088C116.152 298.062 116.098 298.035 116.045 298.017C115.992 297.999 115.938 297.973 115.885 297.946C113.68 296.959 111.813 295.722 111.804 295.722C111.715 297.733 111.609 299.779 111.582 301.789C111.573 302.154 111.573 302.509 111.573 302.865C111.538 312.206 112.489 321.715 113.645 332.238C114.8 342.771 113.645 360.055 113.645 360.055C113.645 360.055 112.071 361.398 103.607 362.581C95.1349 363.755 87.9871 359.414 87.9871 359.414L85.4089 352.084L84.2087 357.688C84.2087 357.688 82.8841 357.973 79.8614 357.128C76.8387 356.274 75.354 355.073 75.354 355.073C75.354 355.073 76.1097 318.824 77.6922 308.959C78.3145 305.089 78.5456 301.931 78.6879 298.898C78.9101 294.21 78.9101 289.878 79.7547 283.811C79.9058 282.699 80.2437 281.721 80.7149 280.831C82.1462 278.136 84.8666 276.463 87.6671 275.423C93.8281 273.136 100.754 273.635 106.426 276.953C106.968 277.273 107.51 277.62 108.035 278.002C108.035 278.002 108.106 278.047 108.239 278.145C109.297 278.847 114.196 282.13 117.032 284.105C117.521 284.443 117.956 284.745 118.285 284.985C118.979 285.492 120.481 284.069 122.304 281.756C122.313 281.747 122.313 281.747 122.313 281.747C127.104 275.636 134.066 263.289 134.066 263.289C134.066 263.289 137.017 263.236 138.946 264.472C140.884 265.691 141.151 268.653 141.151 268.653Z",
    fill: "url(#paint112_linear_430_10862)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M115.885 297.946C113.68 296.959 111.813 295.722 111.804 295.722C111.716 297.733 111.609 299.779 111.582 301.789C111.582 301.789 107.759 292.555 110.009 293.151C112.205 293.712 114.205 297.128 115.885 297.946Z",
    fill: "url(#paint113_linear_430_10862)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M122.313 281.747C122.224 282.05 120.748 286.836 119.112 286.907C117.414 286.987 117.041 284.087 117.041 284.087C117.53 284.425 117.966 284.727 118.295 284.968C118.979 285.475 120.49 284.06 122.313 281.747Z",
    fill: "url(#paint114_linear_430_10862)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7906 345.866C78.2522 349.424 84.2087 357.68 84.2087 357.68C84.2087 357.68 82.8841 357.964 79.8614 357.119C76.8387 356.265 75.354 355.064 75.354 355.064C75.354 355.064 76.1097 318.815 77.6922 308.95C78.3145 305.08 78.5456 301.922 78.6879 298.889C78.9101 294.201 78.9101 289.869 79.7547 283.802C79.9058 282.69 80.2437 281.712 80.7149 280.822L80.7238 280.813C80.7238 280.813 80.4481 301.095 84.4488 302.536C89.0717 304.2 85.5334 305.819 83.0797 309.217C80.3415 313.024 76.9454 333.626 82.1106 336.793C86.7069 339.604 85.3378 342.308 81.7906 345.866Z",
    fill: "url(#paint115_linear_430_10862)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M106.995 327.114L106.701 326.465C108.657 325.576 109.653 324.49 109.662 324.473L110.195 324.953C110.151 324.997 109.084 326.163 106.995 327.114Z",
    fill: "url(#paint116_linear_430_10862)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M107.119 318.815V327.114C106.648 327.328 106.123 327.533 105.546 327.702C103.945 328.182 101.723 328.164 99.9624 328.04V320.567L107.119 318.815Z",
    fill: "url(#paint117_linear_430_10862)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M100.052 328.013C98.4246 327.897 97.2067 327.684 97.1533 327.675L97.2778 326.972C97.2867 326.972 98.5135 327.186 100.105 327.301L100.052 328.013Z",
    fill: "url(#paint118_linear_430_10862)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M105.732 248.354C105.732 248.354 108.47 254.1 106.372 256.626C104.283 259.153 101.474 259.989 101.332 261.732C101.189 263.476 102.407 263.129 102.807 264.294C103.207 265.46 102.523 266.714 102.523 266.714C102.523 266.714 100.185 264.259 99.1001 265.824C98.0155 267.39 97.971 268.929 99.1001 269.489C100.229 270.05 101.234 269.489 101.314 270.299C101.394 271.108 99.5002 273.519 95.8818 272.478C92.2546 271.429 90.6454 269.783 90.1654 267.319C89.6853 264.864 91.1344 261.839 91.1344 261.839C91.1344 261.839 88.6096 256.093 91.6678 253.949C94.7261 251.805 96.7086 252.819 98.1577 252.285C99.6069 251.752 98.5845 249.812 99.9269 249.439C101.269 249.065 102.069 252.179 103.145 251.912C104.221 251.645 103.234 248.265 104.061 246.806C104.888 245.338 105.732 248.354 105.732 248.354Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M104.336 346.169V351.737C104.336 352.858 102.994 353.774 101.34 353.774C99.6868 353.774 98.3354 352.858 98.3354 351.737V346.169C98.3354 347.29 99.6779 348.206 101.34 348.206C103.003 348.206 104.336 347.29 104.336 346.169Z",
    fill: "url(#paint119_linear_430_10862)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M104.336 346.169C104.336 347.29 102.994 348.206 101.34 348.206C99.6868 348.206 98.3354 347.29 98.3354 346.169C98.3354 345.048 99.6779 344.132 101.34 344.132C103.003 344.132 104.336 345.039 104.336 346.169Z",
    fill: "url(#paint120_linear_430_10862)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M612.356 359.45L610.195 401.152C610.204 401.161 610.195 401.161 610.195 401.161L609.395 416.648L599.856 417.351C599.385 413.161 598.949 409.674 598.718 409.087C598.496 408.5 599.047 405.715 599.234 398.884C599.269 397.478 599.287 395.904 599.287 394.142C599.269 380.425 600.203 362.83 602.825 358.533C603.483 357.475 604.319 356.479 605.243 355.58C605.252 355.571 605.261 355.571 605.261 355.571C605.608 355.224 609.822 352.084 610.178 351.773L612.356 359.45Z",
    fill: "url(#paint121_linear_430_10862)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M632.936 416.861L628.038 422.848L614 415.545L613.6 402.068L612.355 359.45L614 353.935L618.125 349.398C618.125 349.398 625.833 350.261 629.647 356.39C633.461 362.536 630.501 392.372 632.581 412.565C632.732 414.086 632.848 415.518 632.936 416.861Z",
    fill: "url(#paint122_linear_430_10862)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M612.347 359.441C612.347 359.441 615.556 359.29 616.756 361.167C617.956 363.044 618.187 364.36 618.187 364.36C618.187 364.36 619.548 350.545 618.107 349.38L613.991 353.917L612.347 359.441Z",
    fill: "#D4DFFC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M612.346 359.441C612.346 359.441 610.124 359.032 608.799 359.992C607.474 360.953 606.994 362.207 606.994 362.207C606.994 362.207 607.972 352.066 610.177 351.755L611.377 355.562L612.346 359.441Z",
    fill: "#D4DFFC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M617.494 344.701L618.116 349.398C618.116 349.398 618.099 354.433 615.929 356.719C613.76 359.005 612.355 359.45 612.355 359.45C612.355 359.45 609.448 357.68 609.946 353.917C610.444 350.154 610.293 348.108 610.293 348.108L612.426 346.729L617.494 344.701Z",
    fill: "url(#paint123_linear_430_10862)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M600.594 336.731C600.594 336.731 600.789 344.087 605.101 348.562C609.413 353.036 611.564 352.12 611.564 352.12C611.564 352.12 617.663 347.521 618.179 342.041C618.694 336.57 611.556 329.169 611.556 329.169L604.861 329.41L600.594 336.731Z",
    fill: "url(#paint124_linear_430_10862)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M598.416 325.22C597.091 326.794 596.22 328.725 596.095 330.771C595.926 333.564 597.153 335.138 600.585 336.731C605.163 338.848 609.44 335.165 610.391 337.149C611.342 339.132 612.044 341.072 612.044 341.072C612.044 341.072 612.925 336.464 614.623 337.585C616.321 338.714 615.094 343.838 617.494 344.692C619.895 345.546 623.629 333.653 619.023 328.324C614.418 322.987 609.946 325.3 607.502 325.593C605.057 325.887 605.475 321.323 602.612 322C601.109 322.346 599.554 323.868 598.416 325.22Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M605.234 355.562C604.318 356.47 603.474 357.457 602.816 358.516C600.193 362.821 599.26 380.408 599.277 394.124C599.277 395.886 599.26 397.46 599.224 398.866L596.388 398.857C596.388 398.857 591.907 394.649 594.717 388.965C597.508 383.272 596.486 373.273 597.375 365.748C598.228 358.462 604.825 355.722 605.234 355.562Z",
    fill: "url(#paint125_linear_430_10862)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M613.6 402.068L610.489 401.641C610.489 401.641 610.382 401.463 610.195 401.152C610.195 401.152 610.204 401.152 610.195 401.143L612.356 359.441L613.6 402.068Z",
    fill: "url(#paint126_linear_430_10862)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M500.382 378.78L581.568 425.677L622.161 402.228L540.975 355.331L500.382 378.78Z",
    fill: "#F3F6FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M622.162 402.228L649.224 417.876V495.195L581.56 535.119L581.568 425.677L622.162 402.228Z",
    fill: "#D4DFFC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M500.382 378.78V488.212L581.559 535.119L581.568 425.677L500.382 378.78Z",
    fill: "url(#paint127_linear_430_10862)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M568.037 496.04L568.028 511.67L554.497 503.851V488.212L568.037 496.04Z",
    fill: "#F3F6FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M556.977 346.934L556.969 382.961L515.406 358.943V322.925L556.977 346.934Z",
    fill: "url(#paint128_linear_430_10862)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M556.969 382.961L559.289 381.795V345.777L556.978 346.934L556.969 382.961Z",
    fill: "url(#paint129_linear_430_10862)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M544.629 379.571L531 387.444L517.362 379.571L531 371.699L544.629 379.571Z",
    fill: "url(#paint130_linear_430_10862)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M559.289 345.777L517.718 321.768L515.406 322.925L556.977 346.934L559.289 345.777Z",
    fill: "#F3F6FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M541.393 349.94L531 343.936L525.781 364.956V376.956L536.192 382.952L536.245 370.436L541.393 349.94Z",
    fill: "url(#paint131_linear_430_10862)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M536.192 382.952L537.348 382.24L537.41 369.715L536.246 370.436L536.192 382.952Z",
    fill: "#F3F6FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M537.41 369.715L542.548 349.22L541.393 349.94L536.245 370.436L537.41 369.715Z",
    fill: "#F3F6FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M542.548 349.22L532.156 343.215L531 343.936L541.393 349.94L542.548 349.22Z",
    fill: "#F3F6FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M544.629 379.571V381.093L531 388.965V387.444L544.629 379.571Z",
    fill: "url(#paint132_linear_430_10862)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M517.362 379.571V381.093L531 388.965V387.444L517.362 379.571Z",
    fill: "url(#paint133_linear_430_10862)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M606.994 399.907L579.932 415.536L552.87 399.907L579.932 384.268L606.994 399.907Z",
    fill: "url(#paint134_linear_430_10862)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M622.161 464.773V496.023L595.099 511.661L595.09 480.402L622.161 464.773Z",
    fill: "url(#paint135_linear_430_10862)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M576.092 391.465C576.092 392.932 577.843 394.124 580.004 394.124C582.164 394.124 583.924 392.932 583.924 391.465C583.924 389.997 582.173 388.805 580.004 388.805C577.834 388.805 576.092 389.997 576.092 391.465Z",
    fill: "url(#paint136_linear_430_10862)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M588.564 398.866C588.564 400.334 590.316 401.526 592.476 401.526C594.637 401.526 596.397 400.334 596.397 398.866C596.397 397.398 594.645 396.206 592.476 396.206C590.316 396.206 588.564 397.398 588.564 398.866Z",
    fill: "url(#paint137_linear_430_10862)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M558.506 497.482C558.151 497.997 558.035 498.691 558.142 499.421C558.222 500.017 558.444 500.648 558.8 501.218C558.968 501.484 559.164 501.742 559.377 501.974C560.649 503.326 562.311 503.513 563.094 502.383C563.876 501.253 563.485 499.243 562.214 497.891C560.951 496.548 559.289 496.361 558.506 497.482Z",
    fill: "url(#paint138_linear_430_10862)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M550.176 531.898V504.918L560.213 500.017L559.591 498.736L548.745 504.029V529.425L520.714 513.227L520.696 381.511L543.917 368.114L543.206 366.877L519.265 380.692L519.291 514.045L550.176 531.898Z",
    fill: "#D4DFFC"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M623.433 401.348L622.233 400.325L617.308 396.126L616.454 395.405C616.454 395.405 626.847 384.25 629.754 379.714C632.652 375.177 625.86 372.793 622.428 363.791C618.997 354.797 624.269 354.068 624.269 354.068C624.269 354.068 627.789 352.912 631.221 357.155C633.648 360.152 637.302 364.903 640.716 374.101C644.139 383.299 623.433 401.348 623.433 401.348Z",
    fill: "url(#paint139_linear_430_10862)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M622.233 400.325C621.877 400.609 621.406 400.912 620.775 401.214C618.632 402.228 617.521 402.477 616.694 403.545C615.859 404.612 615.396 405.956 615.396 405.956C615.396 405.956 609.217 404.07 610.489 401.65C611.493 399.72 614.649 397.113 617.308 396.135L622.233 400.325Z",
    fill: "url(#paint140_linear_430_10862)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M204.672 3.72666C204.032 3.36195 203.294 3.16625 202.548 3.18404C201.881 3.19293 201.214 3.37084 200.565 3.74446L199.276 4.49168L91.8723 66.5469C89.8097 67.7389 88.5295 69.9538 88.5295 72.3378L88.5117 182.126V184.057C88.5117 184.644 88.6273 185.195 88.8318 185.685C89.0985 186.352 89.5341 186.912 90.0675 187.339L86.8137 185.178L86.7959 185.16C85.4979 184.457 84.5645 183.105 84.5645 181.415L84.5822 69.6959C84.5822 67.3119 85.8535 65.0969 87.925 63.9049L196.609 1.11138C198.031 0.284094 199.632 0.417527 200.859 1.17365L201.072 1.31598L204.672 3.72666Z",
    fill: "url(#paint141_linear_430_10862)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M206.779 118.283C206.779 121.272 205.188 124.039 202.592 125.542L94.8949 187.739C93.5257 188.531 91.9877 188.46 90.7609 187.802L90.0763 187.339C89.5429 186.903 89.1073 186.343 88.8406 185.685C88.6361 185.195 88.5205 184.644 88.5205 184.057V182.126L88.5383 72.3378C88.5383 69.9538 89.8185 67.7389 91.881 66.5469L199.285 4.49169L200.574 3.74447C201.223 3.37085 201.89 3.19294 202.556 3.18293C203.312 3.16625 204.05 3.36196 204.681 3.72667L204.717 3.75336C205.926 4.44721 206.779 5.73706 206.779 7.32936V118.283Z",
    fill: "#F3F6FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M108.684 91.0362V138.894L124.224 129.936V82.0606L108.684 91.0362Z",
    fill: "url(#paint142_linear_430_10862)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M139.774 120.952L139.765 61.1117L155.305 52.1361V111.976L139.774 120.952Z",
    fill: "url(#paint143_linear_430_10862)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M170.845 102.992V79.0539L186.385 70.0872V94.0251L170.845 102.992Z",
    fill: "url(#paint144_linear_430_10862)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M111.795 150.583V157.29L123.424 150.583L123.415 143.858L111.795 150.583Z",
    fill: "url(#paint145_linear_430_10862)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M144.947 131.769V138.467L156.576 131.76L156.567 125.044L144.947 131.769Z",
    fill: "url(#paint146_linear_430_10862)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M178.1 115.961V122.669L189.728 115.961L189.719 109.245L178.1 115.961Z",
    fill: "url(#paint147_linear_430_10862)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M231.477 458.608C231.477 458.608 232.935 514.178 233.601 566.386C233.601 566.386 235.104 482.297 235.726 458.608H231.477Z",
    fill: "url(#paint148_linear_430_10862)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M233.602 461.882C242.288 461.882 249.329 454.836 249.329 446.145C249.329 437.455 242.288 430.409 233.602 430.409C224.916 430.409 217.875 437.455 217.875 446.145C217.875 454.836 224.916 461.882 233.602 461.882Z",
    fill: "url(#paint149_linear_430_10862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_430_10862",
    x1: 417.369,
    y1: 514.764,
    x2: 590.188,
    y2: 514.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_430_10862",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.939 180.456) scale(212.725 124.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0324,
    stopColor: "#0E45AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "#4D75C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3456,
    stopColor: "#839FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#B0C2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6395,
    stopColor: "#D2DCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#EBEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_430_10862",
    x1: 494.078,
    y1: 110.968,
    x2: 664.54,
    y2: 110.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_430_10862",
    x1: 612.195,
    y1: 124.506,
    x2: 641.128,
    y2: 124.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_430_10862",
    x1: 592.213,
    y1: 153.983,
    x2: 612.195,
    y2: 153.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_430_10862",
    x1: 583.079,
    y1: 122.007,
    x2: 612.194,
    y2: 122.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_430_10862",
    x1: 592.177,
    y1: 120.417,
    x2: 612.194,
    y2: 120.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_430_10862",
    x1: 612.195,
    y1: 154.87,
    x2: 641.31,
    y2: 154.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_430_10862",
    x1: 583.704,
    y1: 143.319,
    x2: 612.195,
    y2: 143.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_430_10862",
    x1: 507.259,
    y1: 56.3431,
    x2: 568.146,
    y2: 56.3431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_430_10862",
    x1: 507.244,
    y1: 104.342,
    x2: 568.131,
    y2: 104.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_430_10862",
    x1: 521.884,
    y1: 91.7376,
    x2: 553.507,
    y2: 91.7376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_430_10862",
    x1: 514.272,
    y1: 100.538,
    x2: 561.126,
    y2: 100.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_430_10862",
    x1: 514.265,
    y1: 109.32,
    x2: 561.126,
    y2: 109.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_430_10862",
    x1: 513.243,
    y1: 117.827,
    x2: 561.126,
    y2: 117.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_430_10862",
    x1: 622.1,
    y1: 215.234,
    x2: 696.822,
    y2: 215.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_430_10862",
    x1: 632.13,
    y1: 215.633,
    x2: 686.172,
    y2: 215.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_430_10862",
    x1: 649.959,
    y1: 217.26,
    x2: 664.743,
    y2: 217.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_430_10862",
    x1: 658.571,
    y1: 213.982,
    x2: 666.864,
    y2: 213.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_430_10862",
    x1: 466.297,
    y1: 47.7294,
    x2: 517.808,
    y2: 47.7294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_430_10862",
    x1: 473.21,
    y1: 48.0043,
    x2: 510.465,
    y2: 48.0043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_430_10862",
    x1: 485.501,
    y1: 49.1258,
    x2: 495.693,
    y2: 49.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_430_10862",
    x1: 491.439,
    y1: 46.8658,
    x2: 497.156,
    y2: 46.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_430_10862",
    x1: 259.021,
    y1: 514.531,
    x2: 446.427,
    y2: 524.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_430_10862",
    x1: 260.443,
    y1: 491.82,
    x2: 447.85,
    y2: 501.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_430_10862",
    x1: 324.723,
    y1: 493.337,
    x2: 383.615,
    y2: 494.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_430_10862",
    x1: 301.644,
    y1: 460.318,
    x2: 305.153,
    y2: 460.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_430_10862",
    x1: 402.13,
    y1: 457.72,
    x2: 404.591,
    y2: 457.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_430_10862",
    x1: 427.267,
    y1: 490.533,
    x2: 447.115,
    y2: 491.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_430_10862",
    x1: 438.735,
    y1: 517.792,
    x2: 441.674,
    y2: 517.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_430_10862",
    x1: 411.92,
    y1: 525.473,
    x2: 432.852,
    y2: 526.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_430_10862",
    x1: 403.107,
    y1: 524.25,
    x2: 409.462,
    y2: 524.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_430_10862",
    x1: 372.456,
    y1: 545.123,
    x2: 408.403,
    y2: 547.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_430_10862",
    x1: 366.948,
    y1: 544.011,
    x2: 368.419,
    y2: 544.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_430_10862",
    x1: 346.294,
    y1: 538.599,
    x2: 363.168,
    y2: 539.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_430_10862",
    x1: 341.524,
    y1: 544.376,
    x2: 342.578,
    y2: 544.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_430_10862",
    x1: 299.569,
    y1: 526.433,
    x2: 306.881,
    y2: 526.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_430_10862",
    x1: 300.625,
    y1: 546.048,
    x2: 337.932,
    y2: 548.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_430_10862",
    x1: 276.452,
    y1: 527.158,
    x2: 296.887,
    y2: 528.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_430_10862",
    x1: 266.366,
    y1: 519.887,
    x2: 270.511,
    y2: 520.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_430_10862",
    x1: 260.136,
    y1: 493.323,
    x2: 281.921,
    y2: 494.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_430_10862",
    x1: 298.179,
    y1: 477.016,
    x2: 449.001,
    y2: 485.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_430_10862",
    x1: 94.2379,
    y1: 159.25,
    x2: 613.015,
    y2: 159.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#D6E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#C5E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#BFDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_430_10862",
    x1: 94.2382,
    y1: 313.028,
    x2: 613.016,
    y2: 313.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_430_10862",
    x1: 115.097,
    y1: 355.303,
    x2: 162.868,
    y2: 355.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_430_10862",
    x1: 122.995,
    y1: 359.701,
    x2: 170.196,
    y2: 359.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_430_10862",
    x1: 188.23,
    y1: 397.701,
    x2: 236,
    y2: 397.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_430_10862",
    x1: 196.127,
    y1: 402.099,
    x2: 243.329,
    y2: 402.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_430_10862",
    x1: 534.93,
    y1: 360.858,
    x2: 582.701,
    y2: 360.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_430_10862",
    x1: 527.6,
    y1: 365.255,
    x2: 574.802,
    y2: 365.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_430_10862",
    x1: 461.797,
    y1: 403.255,
    x2: 509.568,
    y2: 403.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_430_10862",
    x1: 454.468,
    y1: 407.653,
    x2: 501.671,
    y2: 407.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_430_10862",
    x1: 275.693,
    y1: 224.845,
    x2: 275.664,
    y2: 308.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_430_10862",
    x1: 249.998,
    y1: 191.177,
    x2: 250.413,
    y2: 300.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_430_10862",
    x1: 224.336,
    y1: 237.876,
    x2: 222.343,
    y2: 288.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_430_10862",
    x1: 198.651,
    y1: 243.966,
    x2: 197.593,
    y2: 270.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_430_10862",
    x1: 351.215,
    y1: 332.89,
    x2: 413.591,
    y2: 332.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_430_10862",
    x1: 366.239,
    y1: 319.134,
    x2: 399.141,
    y2: 319.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_430_10862",
    x1: 430.476,
    y1: 286.864,
    x2: 492.845,
    y2: 286.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_430_10862",
    x1: 445.493,
    y1: 273.105,
    x2: 478.394,
    y2: 273.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_430_10862",
    x1: 504.323,
    y1: 243.123,
    x2: 566.692,
    y2: 243.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_430_10862",
    x1: 519.34,
    y1: 229.368,
    x2: 552.248,
    y2: 229.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_430_10862",
    x1: 378.682,
    y1: 311.145,
    x2: 413.591,
    y2: 311.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_430_10862",
    x1: 430.469,
    y1: 265.354,
    x2: 465.902,
    y2: 265.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_430_10862",
    x1: 518.605,
    y1: 239.015,
    x2: 564.719,
    y2: 239.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_430_10862",
    x1: 305.507,
    y1: 257.276,
    x2: 170.387,
    y2: 257.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_430_10862",
    x1: 171.807,
    y1: 208.27,
    x2: 165.433,
    y2: 208.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F22AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_430_10862",
    x1: 281.86,
    y1: 262.977,
    x2: 276.51,
    y2: 262.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_430_10862",
    x1: 256.371,
    y1: 277.641,
    x2: 251.022,
    y2: 277.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_430_10862",
    x1: 224.513,
    y1: 237.574,
    x2: 219.163,
    y2: 237.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_430_10862",
    x1: 205.4,
    y1: 248.238,
    x2: 200.051,
    y2: 248.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_430_10862",
    x1: 0.743648,
    y1: 448.528,
    x2: 101.28,
    y2: 448.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_430_10862",
    x1: 101.28,
    y1: 448.537,
    x2: 201.816,
    y2: 448.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_430_10862",
    x1: 68.2841,
    y1: 459.423,
    x2: 73.7227,
    y2: 459.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_430_10862",
    x1: 77.0173,
    y1: 464.695,
    x2: 82.456,
    y2: 464.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_430_10862",
    x1: 85.7502,
    y1: 469.785,
    x2: 91.1888,
    y2: 469.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_430_10862",
    x1: 16.5994,
    y1: 432.103,
    x2: 27.9952,
    y2: 432.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_430_10862",
    x1: 187.456,
    y1: 425.705,
    x2: 192.894,
    y2: 425.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_430_10862",
    x1: 178.723,
    y1: 430.976,
    x2: 184.161,
    y2: 430.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_430_10862",
    x1: 169.99,
    y1: 436.067,
    x2: 175.428,
    y2: 436.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_430_10862",
    x1: 117.133,
    y1: 465.191,
    x2: 128.529,
    y2: 465.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_430_10862",
    x1: 9.12763,
    y1: 401.698,
    x2: 15.1263,
    y2: 401.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_430_10862",
    x1: 9.12763,
    y1: 397.894,
    x2: 15.1263,
    y2: 397.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_430_10862",
    x1: 100.435,
    y1: 402.905,
    x2: 201.816,
    y2: 402.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    stopColor: "#DAEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#D4E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_430_10862",
    x1: 189.895,
    y1: 400.95,
    x2: 195.893,
    y2: 400.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_430_10862",
    x1: 189.895,
    y1: 397.146,
    x2: 195.893,
    y2: 397.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_430_10862",
    x1: 98.2805,
    y1: 452.401,
    x2: 104.279,
    y2: 452.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_430_10862",
    x1: 98.2805,
    y1: 448.597,
    x2: 104.279,
    y2: 448.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_430_10862",
    x1: 0.79936,
    y1: 481.732,
    x2: 101.336,
    y2: 481.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_430_10862",
    x1: 101.336,
    y1: 481.741,
    x2: 201.872,
    y2: 481.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_430_10862",
    x1: 68.3403,
    y1: 492.627,
    x2: 73.779,
    y2: 492.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_430_10862",
    x1: 77.0732,
    y1: 497.898,
    x2: 82.5119,
    y2: 497.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_430_10862",
    x1: 85.8059,
    y1: 502.989,
    x2: 91.2446,
    y2: 502.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_430_10862",
    x1: 187.511,
    y1: 458.908,
    x2: 192.95,
    y2: 458.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_430_10862",
    x1: 178.778,
    y1: 464.18,
    x2: 184.216,
    y2: 464.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_430_10862",
    x1: 170.045,
    y1: 469.271,
    x2: 175.484,
    y2: 469.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_430_10862",
    x1: 0.745071,
    y1: 514.888,
    x2: 101.282,
    y2: 514.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_430_10862",
    x1: 101.282,
    y1: 514.897,
    x2: 201.817,
    y2: 514.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_430_10862",
    x1: 68.2855,
    y1: 525.783,
    x2: 73.7242,
    y2: 525.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_430_10862",
    x1: 77.0187,
    y1: 531.054,
    x2: 82.4574,
    y2: 531.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_430_10862",
    x1: 85.7516,
    y1: 536.145,
    x2: 91.1902,
    y2: 536.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_430_10862",
    x1: 16.6008,
    y1: 498.463,
    x2: 27.9966,
    y2: 498.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_430_10862",
    x1: 187.457,
    y1: 492.065,
    x2: 192.896,
    y2: 492.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_430_10862",
    x1: 178.724,
    y1: 497.336,
    x2: 184.163,
    y2: 497.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_430_10862",
    x1: 169.991,
    y1: 502.427,
    x2: 175.43,
    y2: 502.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_430_10862",
    x1: 117.134,
    y1: 531.551,
    x2: 128.53,
    y2: 531.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_430_10862",
    x1: 134.685,
    y1: 261.276,
    x2: 143.944,
    y2: 261.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_430_10862",
    x1: 94.3643,
    y1: 383.105,
    x2: 108.418,
    y2: 383.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_430_10862",
    x1: 81.2641,
    y1: 378.016,
    x2: 95.3181,
    y2: 378.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_430_10862",
    x1: 70.8289,
    y1: 295.545,
    x2: 92.0171,
    y2: 295.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1554,
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7728,
    stopColor: "#B0CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_430_10862",
    x1: 93.5903,
    y1: 271.422,
    x2: 103.61,
    y2: 271.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_430_10862",
    x1: 96.19,
    y1: 263.303,
    x2: 108.039,
    y2: 263.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_430_10862",
    x1: 75.3518,
    y1: 313.029,
    x2: 141.155,
    y2: 313.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_430_10862",
    x1: 109.31,
    y1: 297.448,
    x2: 115.889,
    y2: 297.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_430_10862",
    x1: 117.035,
    y1: 284.329,
    x2: 122.31,
    y2: 284.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_430_10862",
    x1: 75.3518,
    y1: 319.267,
    x2: 86.6991,
    y2: 319.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#BFCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5433,
    stopColor: "#D4DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_430_10862",
    x1: 106.701,
    y1: 325.791,
    x2: 110.195,
    y2: 325.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_430_10862",
    x1: 99.9619,
    y1: 323.466,
    x2: 107.117,
    y2: 323.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_430_10862",
    x1: 97.1557,
    y1: 327.488,
    x2: 100.107,
    y2: 327.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_430_10862",
    x1: 98.3369,
    y1: 349.97,
    x2: 104.335,
    y2: 349.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_430_10862",
    x1: 98.3369,
    y1: 346.165,
    x2: 104.335,
    y2: 346.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_430_10862",
    x1: 598.667,
    y1: 384.547,
    x2: 612.352,
    y2: 384.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_430_10862",
    x1: 612.351,
    y1: 386.116,
    x2: 632.937,
    y2: 386.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_430_10862",
    x1: 609.884,
    y1: 352.069,
    x2: 618.116,
    y2: 352.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_430_10862",
    x1: 600.59,
    y1: 340.682,
    x2: 618.196,
    y2: 340.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_430_10862",
    x1: 593.796,
    y1: 377.216,
    x2: 605.238,
    y2: 377.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455,
    stopColor: "#B0CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#C9DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4855,
    stopColor: "#DBE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7242,
    stopColor: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_430_10862",
    x1: 610.193,
    y1: 380.756,
    x2: 613.599,
    y2: 380.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_430_10862",
    x1: 500.379,
    y1: 456.947,
    x2: 581.568,
    y2: 456.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_430_10862",
    x1: 515.408,
    y1: 352.94,
    x2: 556.974,
    y2: 352.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_430_10862",
    x1: 556.973,
    y1: 364.368,
    x2: 559.287,
    y2: 364.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_430_10862",
    x1: 517.365,
    y1: 379.573,
    x2: 544.626,
    y2: 379.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_430_10862",
    x1: 525.784,
    y1: 363.446,
    x2: 541.389,
    y2: 363.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_430_10862",
    x1: 530.997,
    y1: 384.269,
    x2: 544.626,
    y2: 384.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_430_10862",
    x1: 517.365,
    y1: 384.269,
    x2: 530.997,
    y2: 384.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_430_10862",
    x1: 552.872,
    y1: 399.904,
    x2: 606.994,
    y2: 399.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_430_10862",
    x1: 595.09,
    y1: 488.216,
    x2: 622.164,
    y2: 488.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_430_10862",
    x1: 576.092,
    y1: 391.463,
    x2: 583.921,
    y2: 391.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_430_10862",
    x1: 588.563,
    y1: 398.863,
    x2: 596.393,
    y2: 398.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_430_10862",
    x1: 558.101,
    y1: 499.941,
    x2: 563.498,
    y2: 499.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_430_10862",
    x1: 616.456,
    y1: 377.639,
    x2: 641.096,
    y2: 377.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455,
    stopColor: "#B0CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#C9DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4855,
    stopColor: "#DBE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7242,
    stopColor: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_430_10862",
    x1: 610.314,
    y1: 401.036,
    x2: 622.233,
    y2: 401.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_430_10862",
    x1: 84.5749,
    y1: 93.9462,
    x2: 204.675,
    y2: 93.9462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_430_10862",
    x1: 108.682,
    y1: 110.477,
    x2: 124.223,
    y2: 110.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_430_10862",
    x1: 139.763,
    y1: 86.5421,
    x2: 155.303,
    y2: 86.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_430_10862",
    x1: 170.843,
    y1: 86.5375,
    x2: 186.388,
    y2: 86.5375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_430_10862",
    x1: 111.795,
    y1: 150.576,
    x2: 123.426,
    y2: 150.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_430_10862",
    x1: 144.947,
    y1: 131.756,
    x2: 156.577,
    y2: 131.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_430_10862",
    x1: 178.098,
    y1: 115.957,
    x2: 189.728,
    y2: 115.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_430_10862",
    x1: 231.478,
    y1: 512.495,
    x2: 235.729,
    y2: 512.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_430_10862",
    x1: 249.335,
    y1: 446.146,
    x2: 217.873,
    y2: 446.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls13);
export default __webpack_public_path__ + "static/media/ils_13.d700e32aa8ba638d2725f68f479fc1bd.svg";
export { ForwardRef as ReactComponent };